<template>
  <v-content class="pa-12">
    <template>
      <v-row justify="center">
        <v-dialog v-model="detail" max-width="700px">
          <v-card>
            <v-card-text style="font-weight: 900" class="text-start">
              <br />
              เป็น "เครื่องมือแพทย์" ตามประกาศสำนักงานคณะกรรมการอาหารและยา
              คือเข้าข่ายเป็น <br />
              เครื่องมือ เครื่องใช้ อุปกรณ์ เครื่องจักร
              วัตถุที่ใช้ใส่เข้าไปในร่างกายมนุษย์ น้ำยาที่ใช้ตรวจ <br />
              ในห้องปฏิบัติการ และตัวสอบเทียบ (calibrator) ซอฟต์แวร์
              วัสดุหรือสิ่งที่คล้ายกันหรือเกี่ยวข้องกัน <br /><br />
              (1) เจ้าของผลิตภัณฑ์มุ่งหมายที่จะใช้งานโดยลำพัง
              หรือใช้ร่วมกันสำหรับมนุษย์ โดยมีจุดมุ่งหมายเฉพาะอย่างหนึ่งอย่างใด
              หรือมากกว่าดังต่อไปนี้ <br /><br />
              (ก) วินิจฉัย ป้องกัน ติดตาม บำบัด บรรเทา หรือรักษาโรคของมนุษย์
              <br />
              (ข) วินิจฉัย ติดตาม บำบัด บรรเทา หรือรักษาการบาดเจ็บของมนุษย์
              <br />
              (ค) ตรวจสอบ ทดแทน แก้ไข ตัดแปลง พยุง ค้ำ หรือจุนด้าน <br />
              กายวิภาคหรือกระบวนการทางสรีระของร่างกายมนุษย์ <br />
              (ง) ประคับประคองหรือช่วยชีวิตมนุษย์ <br />
              (จ) คุมกำเนิดมนุษย์ <br />
              (ฉ) ทำลายหรือย่ำเชื้อสำหรับเครื่องมือแพทย์ <br />
              (ช) ให้ข้อมูลจากการตรวจสิ่งส่งตรวจจากร่างกายมนุษย์ <br />
              เพื่อวัตถุประสงค์ทางการแพทย์หรือวินิจฉัย <br /><br />
              (2) ผลสัมฤทธิ์ตามความมุ่งหมายของสิ่งที่กล่าวถึงในข้อ (๑)
              ซึ่งเกิดขึ้นในร่างกายมนุษย์ <br />
              ต้องไม่เกิดจากกระบวนการทางเภสัชวิทยา
              วิทยาภูมิคุ้มกันหรือปฏิกิริยาเผาผลาญ <br />
              ให้เกิดพลังงานเป็นหลัก<br /><br />
              <strong style="color: red;">หมายเหตุ: </strong>หากต้องการประเมินเครื่องมือหรือวิธีทดสอบที่ใช้ในการวิจัย (Medical devices) <br />
              สามารถเลือก เหมาะสม หรือ ไม่เหมาะสม เพื่อดำเนินการประเมินต่อ
            </v-card-text>
            <!-- <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="detail = false">ปิด
              </v-btn>
            </v-card-actions> -->
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-layout style="background-color: #faf5f2">
      <v-flex>
        <v-layout justify-end v-if="isRead">
          <v-flex class="text-right">
            <v-btn dark color="gray" @click="printPage()">
              <v-icon>print</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout mb-4>
          <v-flex style="font-size: 28px; font-weight: bold; color: #737373">
            <span>แบบฟอร์ม</span>
          </v-flex>
        </v-layout>

        <div id="print" style="height: auto">
          <div class="print-form">
            <v-layout mx-6>
              <v-flex>
                <v-layout pa-6 mt-3 style="background-color: #3e7662">
                  <v-flex
                    xs8
                    d-flex
                    justify-start
                    style="font-size: 28px; color: white; font-weight: bold"
                  >
                    ใบตอบรับเอกสาร Receipt
                  </v-flex>
                  <v-flex
                    xs4
                    d-flex
                    justify-end
                    align-center
                    style="font-weight: bold; font-size: 13px; color: white"
                  >
                    RO 03_1_2563
                  </v-flex>
                </v-layout>

                <!-- Start Form -->
                <v-form ref="form" v-model="valid" lazy-validation>
                  <!-- Start Card 1 -->
                  <v-card class="mb-12">
                    <v-layout pa-12 class="justify-center">
                      <v-flex xs10>
                        <!-- row 1 -->
                        <v-layout mb-8>
                          <v-flex
                            mr-4
                            xs2
                            class="d-flex justify-end align-center font-weight-bold"
                          >
                            รหัสโครงร่างการวิจัย
                          </v-flex>
                          <v-flex xs4>
                            <TextfieldForm
                              :model="form.researchCode"
                              :readonly="isRead"
                              hide-detail
                              @update-data="updateData('researchCode', $event)"
                            />
                          </v-flex>
                        </v-layout>
                        <!-- row 2 -->
                        <v-layout mb-8>
                          <v-flex
                            mr-4
                            xs2
                            class="d-flex justify-end align-center font-weight-bold"
                          >
                            ชื่อผู้วิจัยหลัก
                          </v-flex>
                          <v-flex xs4>
                            <TextfieldForm
                              :model="form.firstName"
                              :readonly="isRead"
                              hide-detail
                              @update-data="updateData('firstName', $event)"
                            />
                          </v-flex>
                          <v-flex
                            mr-4
                            class="d-flex justify-end align-center font-weight-bold"
                          >
                            นามสกุล
                          </v-flex>
                          <v-flex xs4>
                            <TextfieldForm
                              :model="form.lastName"
                              :readonly="isRead"
                              hide-detail
                              @update-data="updateData('lastName', $event)"
                            />
                          </v-flex>
                        </v-layout>
                        <!-- row 3 -->
                        <v-layout>
                          <v-flex
                            mr-4
                            xs2
                            class="d-flex justify-end align-center font-weight-bold"
                          >
                            ชื่อโครงการวิจัย (ไทย)
                          </v-flex>
                          <v-flex xs10>
                            <textarea-form hide-detail :model="form.researchName"
                            @update-data="updateData('researchName', $event)"></textarea-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                  <!--End Card 1 -->

                  <!-- Start Card 2 -->
                  <v-card class="mb-12">
                    <!-- Start Table -->
                    <v-layout class="table-ro3">
                      <v-flex class="table-style">
                        <table class="table-fill">
                          <!-- row 1 -->
                          <thead>
                            <tr>
                              <th width="5%" class="text-center">ข้อ</th>
                              <th width="45%" class="text-center">
                                หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย
                              </th>
                              <th width="10%" class="text-center">
                                เหมาะสม / ใช่
                              </th>
                              <th width="10%" class="text-center">
                                ไม่เหมาะสม / ไม่ใช่
                              </th>
                              <th width="10%" class="text-center">
                                ไม่เกี่ยวข้อง
                              </th>
                              <th width="30%" class="text-center">ข้อแนะนำ</th>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- Group A Scientific value -->
                            <tr>
                              <td
                                class="text-left"
                                colspan="6"
                                style="
                                  background-color: #fbf6f3;
                                  font-size: 20px;
                                  font-weight: bold;
                                "
                              >
                                <span class="ml-12"
                                  >A Scientific Assessment</span
                                >
                              </td>
                            </tr>
                            <!-- Choice 1 -->

                            <tr class="row2" style="border-top: none">
                              <td class="text-center">
                                <b>1.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>หลักการและเหตุผล(Rationale)</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox1.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox1.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox1.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice1)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice1"
                                  :readonly="isRead"
                                  @update-data="updateData('advice1', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 2 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>2.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >การทบทวนวรรณกรรมที่เกี่ยวข้อง
                                  (Literaturereview)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox2.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox2.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox2.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice2)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice2"
                                  :readonly="isRead"
                                  @update-data="updateData('advice2', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 3 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>3.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>วัตถุประสงค์ (Objective)</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox3.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate3')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox3.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate3')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox3.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate3')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice3)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice3"
                                  :readonly="isRead"
                                  @update-data="updateData('advice3', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 4 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>4.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>รูปแบบการวิจัย (Study design)</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox4.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate4')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox4.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate4')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox4.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate4')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice4)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice4"
                                  :readonly="isRead"
                                  @update-data="updateData('advice4', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 5 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>5.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >กลุ่มประชากรที่ศึกษา (Study population)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox5.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate5')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox5.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate5')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox5.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate5')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice5)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice5"
                                  :readonly="isRead"
                                  @update-data="updateData('advice5', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 6 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>6.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>ขนาดตัวอย่าง (Sample size)</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox6.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate6')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox6.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate6')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox6.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate6')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice6)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice6"
                                  :readonly="isRead"
                                  @update-data="updateData('advice6', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 7 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>7.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >การคัดเลือกอาสาสมัครที่เข้าโครงการ (Inclusion
                                  criteria) ICH-GCP 6.5</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox7.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate7')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox7.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate7')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox7.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate7')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice7)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice7"
                                  :readonly="isRead"
                                  @update-data="updateData('advice7', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 8 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>8.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >การคัดอาสาสมัครออกจากโครงการวิจัย (Exclusion
                                  criteria)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox8.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate8')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox8.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate8')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox8.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate8')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice8)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice8"
                                  :readonly="isRead"
                                  @update-data="updateData('advice8', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 9 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>9.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >การถอนอาสาสมัครออกจากโครงการ (Withdrawal
                                  Criteria)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox9.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate9')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox9.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate9')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox9.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate9')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice9)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice9"
                                  :readonly="isRead"
                                  @update-data="updateData('advice9', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 10 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>10.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >กระบวนการ/หัตถการที่ใช้(Procedures
                                  used)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox10.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate10')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox10.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate10')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox10.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate10')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice10)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice10"
                                  :readonly="isRead"
                                  @update-data="updateData('advice10', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 11 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>11.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  การใช้กลุ่มควบคุมหรือยาหลอก (Placebo
                                  used)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox11.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate11')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox11.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate11')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox11.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate11')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice11)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice11"
                                  :readonly="isRead"
                                  @update-data="updateData('advice11', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 12 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>12.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  เครื่องมือหรือวิธีทดสอบที่ใช้ในการวิจัย
                                  (Medical devices)</span
                                >
                                <br />
                                <a @click="detail = true">{{
                                  "ข้อมูลเพิ่มเติม"
                                }}</a>
                                <div v-if="isCheckbox12.checkbox1 || isCheckbox12.checkbox2">
                                  <b>เอกสารที่ต้องแนบประกอบการพิจารณา</b>
                                  <v-checkbox
                                    v-model="form.checkbox12_1"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="เอกสารแสดงคุณลักษณะเครื่องมือแพทย์ (specification)"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_2"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="เอกสารแสดงวิธีการใช้เครื่องมือแพทย์ (operational mannual)"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_3"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="เอกสารแสดงความเชี่ยวชาญ/การอบรมของผู้ใช้เครื่องมือแพทย์"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_4"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ข้อมูลการศึกษาวิจัยในห้องทดลอง/สัตว์ทดลอง/คน"
                                  ></v-checkbox>
                                  <b>วัตถุประสงค์การวิจัย</b>
                                  <v-checkbox
                                    v-model="form.checkbox12_5"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แสดงถึง intended use"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_6"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="การวัดผลสัมฤทธิ์"
                                  ></v-checkbox>
                                  <b>ลักษณะการวิจัย</b>
                                  <v-checkbox
                                    v-model="form.checkbox12_7"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="เป็นการพัฒนาเครื่องมือแพทย์ใหม่ที่มี intended use เหมือนกับเครื่องมือแพทย์ที่วางจำหน่าย"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_8"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="เป็นการดัดแปลงเครื่องมือแพทย์เพื่อใช้ในวัตถุประสงค์ใหม่"
                                  ></v-checkbox>
                                  <b>ประเภทเครื่องมือ</b>
                                  <v-checkbox
                                    v-model="form.checkbox12_9"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="in vitro diagnositc mdeical device"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_10"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="Non-IVD (Non-invasive)"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_11"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="Non-IVD (Invasive)"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_12"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="Non-IVD (Active)"
                                  ></v-checkbox>
                                  <b
                                    >ประเภทความเสี่ยงตามกองควบคุมเครื่องมือแพทย์</b
                                  >
                                  <v-checkbox
                                    v-model="form.checkbox12_13"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ประเภท 1 มีความเสี่ยงต่ำ (low risk)"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_14"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ประเภท 2 มีความเสี่ยงปานกลางระดับต่ำ (low-moderate risk)"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_15"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ประเภทที่ 3 มีความเสี่ยงปานกลางระดับสูง (moderate-high risk)"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_16"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ประเภทที่ 4 มีความเสี่ยงสูง (high risk)"
                                  ></v-checkbox>
                                  <b>ระยะการวิจัย</b>
                                  <v-checkbox
                                    v-model="form.checkbox12_17"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="Exploratory (First in-human and feasibillty study)"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox12_18"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="Pivotal (หา safety and efficacy/perfomance)"
                                  ></v-checkbox>
                                </div>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox12.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate12')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox12.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate12')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox12.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate12')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice12)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice12"
                                  :readonly="isRead"
                                  @update-data="updateData('advice12', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 13 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>13.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >การศึกษาเกี่ยวกับการเก็บวัตถุทางพันธุศาสตร์และวัสดุชีวภาพ
                                  (ใช้เอกสาร R0 04_2_2563 แนบ)</span
                                >
                                <div v-if="isCheckbox13.checkbox1 || isCheckbox13.checkbox2">
                                  <b>วัตถุประสงค์การวิจัย</b>
                                  <v-checkbox
                                    v-model="form.checkbox13_1"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งอาสาสมัครว่าสิ่งส่งตรวจจะถูกนำไปใช้ในงานวิจัยเกี่ยวกับมนุษยพันธุศาสตร์"
                                  ></v-checkbox>
                                  <b
                                    >ระยะเวลาและรายละเอียดเกี่ยวกับสิ่งส่งตรวจ</b
                                  >
                                  <v-checkbox
                                    v-model="form.checkbox13_2"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งอาสาสมัครว่าระยะเวลาการ เก็บสิ่งส่งตรวจการทำลายเมื่อสิ้นสุดการศึกษา (ถ้าไม่ทำลายต้องแสดงเหตุผล)"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_3"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุสถานที่เก็บและผู้รับผิดชอบการเก็บรักษาสิ่งส่งตรวจ"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_4"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="อธิบายรายละเอียดควบคุมคุณภาพของคลัง เก็บสิ่งส่งตรวจ"
                                  ></v-checkbox>
                                  <b>ความเป็นเจ้าของสิ่งส่งตรวจ</b>
                                  <v-checkbox
                                    v-model="form.checkbox13_5"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="อธิบายว่าใครเป็นเจ้าของสิ่งส่งตรวจ"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_6"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งอาสาสมัครถ้างานวิจัยจะนำไปสู่ผลประโยชน์ใน เชิงพาณิชย์และระบุว่าอาสาสมัครจะได้รับ ผลประโยชน์ด้วยหรือไม่"
                                  ></v-checkbox>
                                  <b>การเข้าถึงข้อมูลผลการตรวจทางพันธุกรรม</b>
                                  <v-checkbox
                                    v-model="form.checkbox13_7"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งว่าอาสาสมัครจะได้รับข้อมูลผลการตรวจหรือไม่ (ถ้าไม่ได้รับ ควรอธิบายเหตุผล)"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_8"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ถ้ามีการแจ้งผล อธิบายกระบวนการ (เช่น การให้คำปรึกษาทางด้านพันธุศาสตร์) และช่วงเวลาของการแจ้งผลการตรวจ"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_9"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุนโยบายการป้องกันการเปิดเผยผลที่เกิดขึ้น โดยไม่ตั้งใจ"
                                  ></v-checkbox>
                                  <b
                                    >การนำสิ่งส่งตรวจไปใช้ในงานวิจัยอื่น
                                    Secondary Use</b
                                  >
                                  <v-checkbox
                                    v-model="form.checkbox13_10"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งอาสาสมัครว่าผู้วิจัยอาจนำสิ่งส่งตรวจนี้ไปใช้งานวิจัยอื่น หรือในอนาคต โดยมีรหัสเชื่อมถึงอาสาสมัคร"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_11"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ขอความยินยอมโดยสมัครใจในการนำสิ่งส่งตรวจนี้ ไปใช้ในปัจจุบัน และ ในอนาคต"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_12"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ให้ทางเลือกแก่อาสาสมัครว่าจะยินยอมให้มีการติดต่อ อาสาสมัครอีกในอนาคตอีกหรือไม่"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_13"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุว่าอาสาสมัครสามารถจำกัดการใช้สิ่งส่งตรวจได้"
                                  ></v-checkbox>
                                  <b>ทางเลือก</b>
                                  <v-checkbox
                                    v-model="form.checkbox13_14"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="อาสาสมัครสามารถตัดสินใจไม่เข้าร่วมในการศึกษาในส่วนเกี่ยวข้องกับพันธุกรรม"
                                  ></v-checkbox>
                                  <b>ความเสี่ยง Risks</b>
                                  <v-checkbox
                                    v-model="form.checkbox13_15"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุความเสี่ยงทางด้านสังคม : การเปิดเผยความลับอาจมีผลต่อความสัมพันธ์
และฐานะทางสังคม (เช่น การทำประกันชีวิต การจ้างงาน สิทธิทางกฎหมาย หรือเป็นตราบาป)"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_16"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุความเสี่ยงทางด้านจิตใจ : การเปิดเผยข้อมูลอาจมีผลต่อจิตใจ ทำให้เกิด
ความเครียดต่อตนเองและครอบครัว 
โดยเฉพาะอย่างยิ่ง ถ้าไม่มีวิธีการรักษา"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_17"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุความเสี่ยงทางกายภาพ : ความเสี่ยงในกระบวนการเก็บสิ่งส่งตรวจเพื่อ
งานวิจัยหรือในกระบวนการทำยีนบำบัด"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_18"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุความเสี่ยงที่ยังไม่ทราบ : อาสาสมัครควรได้รับการบอกว่า อาจมีความ
เสี่ยงอื่นๆ ที่ยังไม่สามารถระบุได้ในขณะนี้"
                                  ></v-checkbox>
                                  <b>ข้อมูลอื่นๆ เกี่ยวกับความเสี่ยง</b>
                                  <v-checkbox
                                    v-model="form.checkbox13_19"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุข้อมูลปัจจุบันที่ทันสมัยเกี่ยวกับยีน
และโรคที่ทำการวิจัย"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_20"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="มีวิธีการรักษาหรือไม่"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_21"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุว่างานวิจัยนี้เกี่ยวข้องกับการทำยีนบำบัดหรือไม่"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_22"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุความเสี่ยงที่จะเกิดขึ้นจากข้อมูลที่อาจเชื่อมโยง
ไปยังบุคคลในครอบครัวของอาสาสัคร"
                                  ></v-checkbox>
                                  <b>ประโยชน์</b>
                                  <v-checkbox
                                    v-model="form.checkbox13_23"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งอาสาสมัครถ้าอาสาสมัครจะไม่ได้รับประโยชน์โดยตรง"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_24"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งอาสาสมัครว่าไม่สามารถยืนยันเรื่องประโยชน์
ที่คาดว่าจะได้รับ"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_25"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งอาสาสมัคร เรื่องประโยชน์ที่คาดว่าจะได้รับ รวมทั้งประโยชน์ในเรื่ององค์ความรู้ประโยชน์ด้านสุขภาพต่อตัวอาสาสมัครครอบครัวสังคมรวมถึง
ประโยชน์ในระยะยาว"
                                  ></v-checkbox>
                                  <b
                                    >การรักษาความลับของข้อมูลและความเป็นส่วนตัว</b
                                  >
                                  <v-checkbox
                                    v-model="form.checkbox13_26"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="มีกระบวนการรักษาความลับของข้อมูล อย่างเหมาะสม
                                    "
                                  ></v-checkbox>
                                  <div
                                    style="color:#544A44; margin-top: -20px; margin-left: 20px; margin-bottom: 20px;"
                                  >
                                    <ul>
                                      <li>
                                        มีการเชื่อมโยงสิ่งส่งตรวจกับอาสาสมัครหรือไม่
                                      </li>
                                      <li>
                                        มีมาตรการการรักษาความลับของข้อมูลเหมาะสมหรือไม่
                                      </li>
                                      <li>
                                        อธิบายข้อจำกัดของการรักษาความลับของข้อมูล
                                        (เช่น ใคร สามารถเข้าถึงข้อมูลได้
                                        หรือกรณีใดต้องมีการเปิดเผยข้อมูล)
                                      </li>
                                    </ul>
                                  </div>
                                  <v-checkbox
                                    v-model="form.checkbox13_27"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุบุคคลที่สาม ที่อาจเข้าถึงข้อมูล เช่น 
ครอบครัว นายจ้าง แพทย์ผู้รักษา"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_28"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุบุคคลที่สาม ที่อาจเข้าถึงข้อมูล เช่น 
ครอบครัว นายจ้าง แพทย์ผู้รักษา"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_29"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="พงศาวลีทางพันธุกรรม(pedigree)ไม่มีระบุชื่อ
อาสาสมัคร ในการตีพิมพ์ผลงานวิจัย"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_30"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="การตีพิมพ์ผลงานวิจัยไม่มีการเปิดเผยชื่อของอาสาสมัคร (ยกเว้นแต่ได้รับอนุญาต)"
                                  ></v-checkbox>
                                  <b>ค่าใช้จ่าย</b>
                                  <v-checkbox
                                    v-model="form.checkbox13_31"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งอาสาสมัคร เรื่องค่าใช้จ่ายที่ไม่ครอบคลุมในการวิจัยนี้ เช่น ค่าใช้จ่ายในการให้คำปรึกษาด้านพันธุกรรมศาสตร์ ค่าใช้จ่ายของการปรึกษาปัญหาด้านสุขภาพจิต เป็นต้น"
                                  ></v-checkbox>
                                  <b>การมีข้อมูลผลการตรวจที่สำคัญ</b>
                                  <v-checkbox
                                    v-model="form.checkbox13_32"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="อภิปรายแนวทางเกี่ยวกับความต้องการของอาสาสมัคร
ในการรับทราบข้อมูลถ้าผลการตรวจในเวลาต่อมามีความ
เกี่ยวข้องกับสุขภาพ"
                                  ></v-checkbox>
                                  <b>การถอนตัวออกจากโครงการวิจัย</b>
                                  <v-checkbox
                                    v-model="form.checkbox13_33"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งว่าอาสาสมัครสามารถถอนตัวออกจากโครงการวิจัย
ได้ตลอดเวลาโดยไม่มีผลกระทบใดๆ"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_34"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งกระบวนการที่อาสาสมัครสามารถขอให้ทำลาย
สิ่งส่งตรวจได้หรือไม่"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_35"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="แจ้งกระบวนการที่อาสาสมัครสามารถร้องขอให้ทำสิ่งส่งตรวจเป็นตัวอย่างนิรนามหรือไม่มีรหัสที่สามารถเชื่อมโยง
ถึงตัวอาสาสมัครได้"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_36"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="อธิบายข้อจำกัดของอาสาสมัครในการถอนข้อมูลหรือตัวอย่างสิ่งส่งตรวจทางพันธุกรรม"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox13_37"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ระบุจำนวนอาสาสมัครที่เข้าร่วมในโครงการวิจัย"
                                  ></v-checkbox>
                                </div>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox13.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate13')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox13.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate13')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox13.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate13')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice13)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice13"
                                  :readonly="isRead"
                                  @update-data="updateData('advice13', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 14 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>14.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >วิธีการวัดผลการวิจัย (Research
                                  assessment)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox14.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate14')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox14.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate14')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox14.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate14')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice14)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice14"
                                  :readonly="isRead"
                                  @update-data="updateData('advice14', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 14.1 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>14.1</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span> การประเมินประสิทธิภาพ (Efficacy)</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox14_1.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate14_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox14_1.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate14_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox14_1.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate14_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice14_1)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice14_1"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice14_1', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 14.2 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>14.2</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span> การประเมินความปลอดภัย (Safety)</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox14_2.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate14_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox14_2.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate14_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox14_2.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate14_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice14_2)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice14_2"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice14_2', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 15 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>15.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  การเฝ้าระวังผลแทรกซ้อนและการแก้ไข (Monitoring
                                  of complications and solutions)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox15.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate15')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox15.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate15')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox15.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate15')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice15)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice15"
                                  :readonly="isRead"
                                  @update-data="updateData('advice15', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 16 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>16.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  จํานวนและปริมาณของเลือด/สิ่งส่งตรวจ
                                  (Blood/specimen)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox16.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate16')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox16.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate16')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox16.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate16')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice16)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice16"
                                  :readonly="isRead"
                                  @update-data="updateData('advice16', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 17 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>17.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >ระยะเวลา/จํานวนครั้งของการติดตาม (Duration
                                  and number of follow-up)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox17.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate17')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox17.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate17')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox17.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate17')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice17)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice17"
                                  :readonly="isRead"
                                  @update-data="updateData('advice17', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 18 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>18.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >สถิติที่ใช้ในการวิเคราะห์(Statistics)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox18.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate18')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox18.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate18')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox18.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate18')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice18)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice18"
                                  :readonly="isRead"
                                  @update-data="updateData('advice18', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 19 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>19.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <!-- {{ "Test" + isCheckbox44.checkbox1 }} -->
                                <span
                                  >แนวทางการทบทวนและนำเสนอเอกสารทางคลินิกระยะที่
                                  4</span
                                >
                                <div v-if="isCheckbox44.checkbox1 || isCheckbox44.checkbox2">
                                  <v-checkbox
                                    v-model="form.checkbox19_1"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="มีความจำเป็นต้องทำวิจัยและสามารถสร้างองค์ความรู้ใหม่"
                                  >
                                  </v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox19_2"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ได้แนบเอกสารแนวทางเวชปฏิบัติมาตรฐาน(clinical practice guideline)"
                                  >
                                  </v-checkbox>
                                  <b>ประเมินระดับผลประโยชน์ทับซ้อน</b>
                                  <v-checkbox
                                    v-model="form.checkbox19_3"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ไม่มี"
                                  >
                                  </v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox19_4"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="มีแต่ไม่กระทบให้มีความเสี่ยงร้ายแรงต่ออาสาสมัคร/จงใจให้เกิดพฤติกรรมไม่เหมาะสมในการดำเนินการวิจัย"
                                  >
                                  </v-checkbox>
                                  <b
                                    >แนวทางการจัดการผลประโยชน์ทับซ้อนเหมาะสมหรือไม่</b
                                  >
                                  <v-checkbox
                                    v-model="form.checkbox19_5"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="ตัดผลประโยชน์ทับซ้อนทางการเงิน (financial COI)"
                                  >
                                  </v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox19_6"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="สนับสนุนนยา/เครื่องมือการวิจัย"
                                  >
                                  </v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox19_7"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="จ่ายค่าตอบแทนให้เหมาะสมกับภาระงาน"
                                  >
                                  </v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox19_8"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="จำกัดบทบาทผู้มีผลประโยชน์ทับซ้อน"
                                  >
                                  </v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox19_9"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="การคัดเลือกและขอคำยินยอนดำเนินการโดยบุคคลไม่มีส่วนได้เสีย"
                                  >
                                  </v-checkbox>
                                  <v-checkbox
                                    v-model="form.checkbox19_10"
                                    :readonly="isRead"
                                    v-bind:true-value="1"
                                    v-bind:false-value="0"
                                    color="#3E7662"
                                    label="การเปิดเผยผลประโยชน์ทับซ้อนอย่งาเหมาะสม"
                                  >
                                  </v-checkbox>
                                </div>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox44.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate44')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox44.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate44')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox44.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate44')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice44)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice44"
                                  :readonly="isRead"
                                  @update-data="updateData('advice44', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- Group B Risk/Benefit assessment -->
                        <table class="table-fill page_break">
                          <thead>
                            <tr>
                              <th width="5%" class="text-center">ข้อ</th>
                              <th width="45%" class="text-center">
                                หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย
                              </th>
                              <th width="10%" class="text-center">
                                เหมาะสม / ใช่
                              </th>
                              <th width="10%" class="text-center">
                                ไม่เหมาะสม / ไม่ใช่
                              </th>
                              <th width="10%" class="text-center">
                                ไม่เกี่ยวข้อง
                              </th>
                              <th width="30%" class="text-center">ข้อแนะนำ</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="page_break">
                              <td
                                class="text-left"
                                colspan="6"
                                style="
                                  background-color: #fbf6f3;
                                  font-size: 20px;
                                  font-weight: bold;
                                "
                              >
                                <span class="ml-12">B Ethical Issue</span>
                              </td>
                            </tr>
                            <!-- Choice 19 -->
                            <tr class="row2" style="border-top: none">
                              <td class="text-center">
                                <b>1.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >การใช้อาสาสมัครกลุ่มเปราะบาง (Vulnerable
                                  participants)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox19.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate19')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox19.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate19')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox19.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate19')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice19)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice19"
                                  :readonly="isRead"
                                  @update-data="updateData('advice19', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 19.1 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>1.1</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  style="
                                    font-family: Kanit, Roboto, sans-serif;
                                    font-size: 16px;
                                  "
                                >
                                  การจัดกลุ่มเปราะบาง(Identification)
                                </span>
                                <v-checkbox
                                  v-model="form.isCognitive"
                                  color="#3E7662"
                                  label="บุคคลผู้ขาดความสามารถในการตัดสินใจ หรือมีปัญหาในการสื่อสาร เช่น เด็ก ผู้ป่วยโรคสมอง ผู้ป่วยฉุกเฉิน หรือใช้ภาษาท้องถิ่น(Cognitive / communication)"
                                >
                                </v-checkbox>
                                <v-checkbox
                                  v-model="form.isInstitutional"
                                  color="#3E7662"
                                  label="บุคคลผู้ขาดอิสระในการตัดสินใจ เพราะตกอยู่ภายใต้อํานาจหรือการปกครอง เช่น ทหารเกณฑ์นักโทษ (Institutional)"
                                >
                                </v-checkbox>
                                <v-checkbox
                                  v-model="form.isDeferral"
                                  color="#3E7662"
                                  label="บุคคลผู้ไม่เท่าเทียมในทางสังคม เช่น ผู้ป่วยของแพทย์ผู้วิจัย นักเรียนของอาจารย์นักวิจัย(Deferral)"
                                >
                                </v-checkbox>
                                <v-checkbox
                                  v-model="form.isMedical"
                                  color="#3E7662"
                                  label="บุคคลผู้เจ็บป่วยร้ายแรง เช่น มะเร็งระยะสุดท้าย (Medical)"
                                >
                                </v-checkbox>
                                <v-checkbox
                                  v-model="form.isEconomic"
                                  color="#3E7662"
                                  label="บุคคลผู้ขาดโอกาสในการเข้าถึงการบริการสุขภาพ (Economic)"
                                >
                                </v-checkbox>
                                <v-checkbox
                                  v-model="form.isSocial"
                                  color="#3E7662"
                                  label="บุคคลที่ถูกแบ่งแยก กีดกันในสังคม เช่น กลุ่มชาติพันธุ์คนเร่ร่อน(Social)"
                                >
                                </v-checkbox>
                                <v-checkbox
                                  v-model="form.isOtherAnswer"
                                  color="#3E7662"
                                  label="อื่นๆ ระบุ"
                                >
                                </v-checkbox>
                                <textfield-form
                                  :disabled="!form.isOtherAnswer"
                                  :model="form.otherAnswer"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('otherAnswer', $event)
                                  "
                                ></textfield-form>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox19_1.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate19_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox19_1.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate19_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox19_1.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate19_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice19_1)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice19_1"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice19_1', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 19.2 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>1.2</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  การปกป้องคุ้มครองเพิ่มเติม (Additional
                                  safeguard)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox19_2.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate19_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox19_2.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate19_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox19_2.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate19_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice19_2)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice19_2"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice19_2', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 20 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>2.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >ความเสี่ยงต่อสุขภาพของอาสาสมัคร (Risks to the
                                  health)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox20.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate20')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox20.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate20')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox20.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate20')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice20)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice20"
                                  :readonly="isRead"
                                  @update-data="updateData('advice20', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 20.1 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>2.1</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>ความเสี่ยงทางกาย (Physical risk)</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox20_1.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate20_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox20_1.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate20_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox20_1.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate20_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice20_1)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice20_1"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice20_1', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 20.2 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>2.2</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >ความเสี่ยงทางจิตใจ (Psychological risk)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox20_2.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate20_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox20_2.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate20_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox20_2.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate20_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice20_2)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice20_2"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice20_2', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 20.3 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>2.3</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >ความเสี่ยงอื่น ๆ เช่น เศรษฐสถานะ กฎหมาย
                                  หรือความเสี่ยงในการรักษาความลับ (Economic,
                                  legal, breach of confidentiality)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox20_3.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate20_3')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox20_3.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate20_3')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox20_3.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate20_3')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice20_3)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice20_3"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice20_3', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 20.4 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>2.4</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  การลดความเสี่ยง (Minimizing the risk)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox20_4.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate20_4')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox20_4.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate20_4')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox20_4.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate20_4')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice20_4)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice20_4"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice20_4', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 21 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>3.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  ความเสี่ยงต่อสุขภาพของตัวอ่อนหรือบุตรในครรภ์หรือคู่สมรส
                                  (Risks to the health of the embryo or unborn
                                  child)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox21.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate21')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox21.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate21')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox21.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate21')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice21)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice21"
                                  :readonly="isRead"
                                  @update-data="updateData('advice21', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 22 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>4.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  ผลกระทบต่อชุมชนที่เข้าร่วมการวิจัย (Risks to
                                  community)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox22.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate22')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox22.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate22')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox22.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate22')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice22)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice22"
                                  :readonly="isRead"
                                  @update-data="updateData('advice22', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 23 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>5.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  ประโยชน์ต่ออาสาสมัครโดยตรง(Direct
                                  benefits)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox23.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate23')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox23.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate23')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox23.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate23')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice23)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice23"
                                  :readonly="isRead"
                                  @update-data="updateData('advice23', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 23.1 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>5.1</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span> ขณะเข้าร่วม (During the study)</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox23_1.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate23_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox23_1.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate23_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox23_1.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate23_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice23_1)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice23_1"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice23_1', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 23.2 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>5.2</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  หลังการเข้าร่วม (Post-study benefits)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox23_2.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate23_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox23_2.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate23_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox23_2.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate23_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice23_2)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice23_2"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice23_2', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 24 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>6.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >ประโยชน์ต่อชุมชนที่เข้าร่วมการวิจัย(Benefits
                                  to community)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox24.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate24')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox24.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate24')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox24.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate24')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice24)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice24"
                                  :readonly="isRead"
                                  @update-data="updateData('advice24', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 25 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>7.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >ประโยชน์ต่อสังคม(Benefits to society)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox25.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate25')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox25.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate25')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox25.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate25')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice25)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice25"
                                  :readonly="isRead"
                                  @update-data="updateData('advice25', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 25.1 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>8.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  การประเมินประโยชน์และความเสี่ยง (Benefit/risk
                                  ratio)</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox25_1.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate25_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox25_1.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate25_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox25_1.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate25_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice25_1)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice25_1"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice25_1', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- row 2 -->
                        <table class="table-fill">
                          <thead>
                            <tr>
                              <th width="5%" class="text-center">ข้อ</th>
                              <th width="45%" class="text-center">
                                หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย
                              </th>
                              <th width="10%" class="text-center">
                                เหมาะสม / ใช่
                              </th>
                              <th width="10%" class="text-center">
                                ไม่เหมาะสม / ไม่ใช่
                              </th>
                              <th width="10%" class="text-center">
                                ไม่เกี่ยวข้อง
                              </th>
                              <th width="30%" class="text-center">ข้อแนะนำ</th>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- Group C Informed Consent Process -->
                            <tr>
                              <td
                                class="text-left"
                                colspan="6"
                                style="
                                  background-color: #fbf6f3;
                                  font-size: 20px;
                                  font-weight: bold;
                                "
                              >
                                <span class="ml-12"
                                  >C Informed Consent Process</span
                                >
                              </td>
                            </tr>
                            <!-- Choice 26 -->
                            <tr class="row2" style="border-top: none">
                              <td class="text-center">
                                <b>1.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span> กระบวนการขอความยินยอม</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox26.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate26')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate26')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate26')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice26)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice26"
                                  :readonly="isRead"
                                  @update-data="updateData('advice26', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 26.1 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>1.1</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span> บุคคลที่ทําการขอความยินยอม</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox26_1.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate26_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_1.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate26_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_1.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate26_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice26_1)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice26_1"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice26_1', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 26.2 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>1.2</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span> ช่วงเวลาที่ทําการขอความยินยอม</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox26_2.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate26_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_2.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate26_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_2.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate26_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice26_2)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice26_2"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice26_2', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 26.3 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>1.3</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span> สถานที่ที่ทําการขอความยินยอม</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox26_3.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate26_3')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_3.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate26_3')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_3.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate26_3')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice26_3)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice26_3"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice26_3', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 26.4 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>1.4</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  กระบวนการเชิญชวนอาสาสมัครเข้าร่วมโครงการวิจัย</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox26_4.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate26_4')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_4.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate26_4')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_4.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate26_4')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice26_4)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice26_4"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice26_4', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 26.5 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>1.5</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  ความมีอิสระในการตัดสินใจของผู้เข้าร่วมโครงการวิจัย</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox26_5.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate26_5')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_5.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate26_5')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_5.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate26_5')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice26_5)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice26_5"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice26_5', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 26.6 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>1.6</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>
                                  รูปแบบและวิธีการสื่อสารข้อมูลกับอาสาสมัคร</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox26_6.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate26_6')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_6.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate26_6')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox26_6.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate26_6')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice26_6)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice26_6"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice26_6', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Group D  Information sheet -->
                            <tr>
                              <td
                                class="text-left"
                                colspan="6"
                                style="
                                  background-color: #fbf6f3;
                                  font-size: 20px;
                                  font-weight: bold;
                                "
                              >
                                <span class="ml-12">D Information sheet</span>
                              </td>
                            </tr>
                            <!-- Choice 27 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>1.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>การแจ้งหลักการและเหตุผล</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox27.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate27')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox27.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate27')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox27.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate27')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice27)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice27"
                                  :readonly="isRead"
                                  @update-data="updateData('advice27', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 28 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>2.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>การแจ้งวัตถุประสงค์ของการวิจัย</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox28.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate28')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox28.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate28')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox28.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate28')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice28)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice28"
                                  :readonly="isRead"
                                  @update-data="updateData('advice28', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 29 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>3.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>ระบุแหล่งทุนสนับสนุน</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox29.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate29')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox29.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate29')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox29.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate29')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice29)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice29"
                                  :readonly="isRead"
                                  @update-data="updateData('advice29', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 30 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>4.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>ขั้นตอนการปฏิบัติตัวของอาสาสมัคร</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox30.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate30')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox30.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate30')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox30.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate30')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice30)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice30"
                                  :readonly="isRead"
                                  @update-data="updateData('advice30', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 31 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>5.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>ระบุความเสี่ยงและผลแทรกซ้อน</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox31.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate31')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox31.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate31')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox31.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate31')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice31)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice31"
                                  :readonly="isRead"
                                  @update-data="updateData('advice31', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 32 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>6.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >ประโยชน์ที่ได้รับจากการเข้าร่วมวิจัย</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox32.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate32')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox32.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate32')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox32.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate32')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice32)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice32"
                                  :readonly="isRead"
                                  @update-data="updateData('advice32', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 33 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>7.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>ความเป็นอิสระในการตัดสินใจ</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox33.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate33')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox33.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate33')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox33.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate33')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice33)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice33"
                                  :readonly="isRead"
                                  @update-data="updateData('advice33', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 33.1 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>7.1</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>การเข้าร่วมโครงการเป็นโดยสมัครใจ</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox33_1.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate33_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox33_1.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate33_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox33_1.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate33_1')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice33_1)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice33_1"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice33_1', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 33.2 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>7.2</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>สิทธิในการถอนตัวจากโครงการวิจัย</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox33_2.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate33_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox33_2.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate33_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox33_2.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate33_2')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice33_2)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice33_2"
                                  :readonly="isRead"
                                  @update-data="
                                    updateData('advice33_2', $event)
                                  "
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 34 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>8.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>ทางเลือกอื่นหากไม่เข้าร่วมโครงการ</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox34.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate34')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox34.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate34')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox34.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate34')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice34)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice34"
                                  :readonly="isRead"
                                  @update-data="updateData('advice34', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 35 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>9.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >การให้การดูแลทางการแพทย์ขณะเข้าร่วมงานวิจัย</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox35.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate35')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox35.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate35')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox35.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate35')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice35)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice35"
                                  :readonly="isRead"
                                  @update-data="updateData('advice35', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 36 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>10.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >การจ่ายค่าตอบแทน/ค่าเดินทาง/ค่าใช้จ่าย/ค่าชดเชยแก่อาสาสมัคร</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox36.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate36')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox36.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate36')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox36.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate36')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice36)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice36"
                                  :readonly="isRead"
                                  @update-data="updateData('advice36', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 37 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>11.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>การเก็บรักษาความลับของอาสาสมัคร</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox37.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate37')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox37.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate37')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox37.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate37')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice37)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice37"
                                  :readonly="isRead"
                                  @update-data="updateData('advice37', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 38 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>12.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >ชื่อ
                                  ที่อยู่และเบอร์โทรศัพท์ติดต่อผู้วิจัย</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox38.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate38')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox38.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate38')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox38.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate38')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice38)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice38"
                                  :readonly="isRead"
                                  @update-data="updateData('advice38', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 39 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>13.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >ที่อยู่และเบอร์โทรศัพท์ติดต่อคณะกรรมการ</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox39.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate39')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox39.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate39')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox39.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate39')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice39)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice39"
                                  :readonly="isRead"
                                  @update-data="updateData('advice39', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 40 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>14.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>การใช้ภาษาที่เหมาะสม</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox40.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate40')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox40.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate40')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox40.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate40')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice40)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice40"
                                  :readonly="isRead"
                                  @update-data="updateData('advice40', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Group D Informed Consent -->
                            <tr>
                              <td
                                class="text-left"
                                colspan="6"
                                style="
                                  background-color: #fbf6f3;
                                  font-size: 20px;
                                  font-weight: bold;
                                "
                              >
                                <span class="ml-12">E Investigator</span>
                              </td>
                            </tr>
                            <!-- Choice 41 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>15.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >พื้นฐานอาชีพและประสบการณ์ของผู้วิจัย</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox41.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate41')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox41.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate41')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox41.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate41')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice41)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice41"
                                  :readonly="isRead"
                                  @update-data="updateData('advice41', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 42 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>16.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span>Conflict of interest</span>
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox42.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate42')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox42.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate42')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox42.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate42')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice42)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice42"
                                  :readonly="isRead"
                                  @update-data="updateData('advice42', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                            <!-- Choice 43 -->
                            <tr class="row2">
                              <td class="text-center">
                                <b>17.</b>
                              </td>
                              <td class="text-left text-field-center">
                                <span
                                  >ประวัติการอบรมจริยธรรมการวิจัยของผู้วิจัย
                                  และผู้ร่วมโครงการวิจัย</span
                                >
                              </td>
                              <td class="text-xs-center">
                                <v-checkbox
                                  v-model="isCheckbox43.checkbox1"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 1, 'isAppropriate43')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox43.checkbox2"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 2, 'isAppropriate43')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-left text-field-center">
                                <v-checkbox
                                  v-model="isCheckbox43.checkbox3"
                                  :readonly="isRead"
                                  color="#3E7662"
                                  hide-details
                                  @change="
                                    checkbox($event, 3, 'isAppropriate43')
                                  "
                                ></v-checkbox>
                              </td>
                              <td class="text-center">
                                <div
                                  v-if="printMode"
                                  class="text-left"
                                  v-html="replaceWithBr(form.advice43)"
                                ></div>
                                <TextareaForm
                                  v-if="!printMode"
                                  :model="form.advice43"
                                  :readonly="isRead"
                                  @update-data="updateData('advice43', $event)"
                                  hide-detail
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </v-flex>
                    </v-layout>
                    <!-- End Table -->

                    <!-- Start Form -->
                    <v-layout class="pa-12">
                      <v-flex>
                        <!-- Group 4 -->
                        <v-layout mb-2>
                          <v-flex class="text-start font-weight-bold mb-2">
                            <span
                              >ข้อเสนอแนะเพิ่มเติมในส่วนของวิธีการดําเนินการวิจัย
                              (Scientific Assessment)</span
                            >
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex shrink>
                            <v-btn
                              color="#3E7662"
                              dark
                              @click="onClickGenerate('adviceResearcher')"
                            >
                              <v-icon class="pr-3">archive</v-icon>
                              <span class="font-weight-bold">Generate</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-layout class="mb-12">
                          <v-flex>
                            <div
                              v-if="printMode"
                              class="text-left"
                              v-html="replaceWithBr(form.adviceResearcher)"
                            ></div>
                            <textarea-form
                              v-if="!printMode"
                              :model="form.adviceResearcher"
                              :readonly="isRead"
                              hide-detail
                              @update-data="
                                updateData('adviceResearcher', $event)
                              "
                            />
                          </v-flex>
                        </v-layout>

                        <!-- Group 5 -->
                        <v-layout mb-2>
                          <v-flex class="text-start font-weight-bold mb-2">
                            <span
                              >ข้อเสนอแนะเพิ่มเติมประเด็นจริยธรรมการวิจัย
                              (Ethical Issue)</span
                            >
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex shrink>
                            <v-btn
                              color="#3E7662"
                              dark
                              @click="onClickGenerate('adviceEthical')"
                            >
                              <v-icon class="pr-3">archive</v-icon>
                              <span class="font-weight-bold">Generate</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-layout class="mb-12">
                          <v-flex>
                            <div
                              v-if="printMode"
                              class="text-left"
                              v-html="replaceWithBr(form.adviceEthical)"
                            ></div>
                            <textarea-form
                              v-if="!printMode"
                              :model="form.adviceEthical"
                              :readonly="isRead"
                              hide-detail
                              @update-data="updateData('adviceEthical', $event)"
                            />
                          </v-flex>
                        </v-layout>

                        <!-- Group 2 -->
                        <v-layout mb-2>
                          <v-flex class="text-start font-weight-bold mb-2">
                            <span
                              >ข้อเสนอแนะเพิ่มเติมกระบวนการขอความยินยอม
                              (Informed Consent Process)</span
                            >
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex shrink>
                            <v-btn
                              color="#3E7662"
                              dark
                              @click="onClickGenerate('adviceProcess')"
                            >
                              <v-icon class="pr-3">archive</v-icon>
                              <span class="font-weight-bold">Generate</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-layout class="mb-12">
                          <v-flex>
                            <div
                              v-if="printMode"
                              class="text-left"
                              v-html="replaceWithBr(form.adviceProcess)"
                            ></div>
                            <textarea-form
                              v-if="!printMode"
                              :model="form.adviceProcess"
                              :readonly="isRead"
                              hide-detail
                              @update-data="updateData('adviceProcess', $event)"
                            />
                          </v-flex>
                        </v-layout>
                        <!-- Group 3 -->
                        <v-layout mb-2>
                          <v-flex class="text-start font-weight-bold mb-2">
                            <span
                              >ข้อเสนอแนะเพิ่มเติมเอกสารชี้แจงข้อมูลอาสาสมัคร
                              (Information sheet)</span
                            >
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex shrink>
                            <v-btn
                              color="#3E7662"
                              dark
                              @click="onClickGenerate('adviceDoc')"
                            >
                              <v-icon class="pr-3">archive</v-icon>
                              <span class="font-weight-bold">Generate</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-layout class="mb-12">
                          <v-flex>
                            <div
                              v-if="printMode"
                              class="text-left"
                              v-html="replaceWithBr(form.adviceDoc)"
                            ></div>
                            <textarea-form
                              v-if="!printMode"
                              :model="form.adviceDoc"
                              :readonly="isRead"
                              hide-detail
                              @update-data="updateData('adviceDoc', $event)"
                            />
                          </v-flex>
                        </v-layout>
                        <!-- Group 1 -->
                        <v-layout mb-2>
                          <v-flex class="text-start font-weight-bold mb-2">
                            <span>ข้อเสนอแนะเพิ่มเติมอื่นๆ</span>
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex shrink>
                            <v-btn
                              color="#3E7662"
                              dark
                              @click="onClickGenerate('adviceResearch')"
                            >
                              <v-icon class="pr-3">archive</v-icon>
                              <span class="font-weight-bold">Generate</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-layout class="mb-12">
                          <v-flex>
                            <div
                              v-if="printMode"
                              class="text-left"
                              v-html="replaceWithBr(form.adviceResearch)"
                            ></div>
                            <textarea-form
                              v-if="!printMode"
                              :model="form.adviceResearch"
                              :readonly="isRead"
                              hide-detail
                              @update-data="
                                updateData('adviceResearch', $event)
                              "
                            />
                          </v-flex>
                        </v-layout>

                        <!-- Sumary -->
                        <v-layout ml-6>
                          <v-flex class="text-start font-weight-bold mb-2">
                            <span>สรุปความเห็น</span>
                          </v-flex>
                        </v-layout>

                        <!-- อัตราส่วนระหว่างความเสี่ยงและผลประโยชน์ (risk /benefit ratio) -->
                        <v-layout mt-6 ml-12>
                          <v-flex class="text-start font-weight-bold mb-2">
                            <span
                              >อัตราส่วนระหว่างความเสี่ยงและผลประโยชน์ (risk
                              /benefit ratio)</span
                            >
                          </v-flex>
                        </v-layout>
                        <v-layout style="margin-left: 70px" mt-2>
                          <v-flex class="text-start">
                            <v-radio-group
                              :readonly="isRead"
                              v-model="form.riskRatio"
                              row
                              @change="updateData('riskRatio', $event)"
                            >
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 40px"
                                label="เหมาะสม"
                                value="1"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 40px"
                                label="ไม่เหมาะสม"
                                value="2"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                label="ยังประเมินไม่ได้"
                                value="3"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>

                        <!-- ความรุนแรงของความเสี่ยง (risk categories) -->
                        <v-layout mt-6 ml-12>
                          <v-flex class="text-start font-weight-bold mb-2">
                            <span
                              >ความรุนแรงของความเสี่ยง (risk categories)</span
                            >
                          </v-flex>
                        </v-layout>
                        <v-layout style="margin-left: 70px">
                          <v-flex class="text-start">
                            <v-radio-group
                              :readonly="isRead"
                              v-model="form.riskCategories"
                              @change="updateData('riskCategories', $event)"
                            >
                              <v-radio
                                color="#3E7662"
                                style="margin-bottom: 20px; margin-top: 10px"
                                label="1. มีความเสี่ยงไม่เกินความเสี่ยงเล็กน้อย (Research not involving greater than minimal risk)"
                                value="1"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                style="margin-bottom: 20px"
                                label="2. มีความเสี่ยงเกินความเสี่ยงเล็กน้อย แต่มีประโยชน์ต่อตัวอาสาสมัครโดยตรง (Research involving greater than minimal risk but presenting the prospect of direct benefit to the individual subjects)"
                                value="2"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                style="margin-bottom: 20px"
                                label="3 มีความเสี่ยงเกินความเสี่ยงเล็กน้อยและไม่มีประโยชน์ต่ออาสาสมัครที่เข้าร่วมในโครงการวิจัยแต่มีความเป็นไปได้ที่จะได้รับความรู้เกี่ยวกับโรคหรือสภาวะที่อาสาสมัครเป็น
                                                             (Research involving greater than minimal risk and no prospect of direct benefit to the individual subjects,
                                                              but likely to yield generalizable knowledge about the subject’s disorder or condition)"
                                value="3"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>

                        <!-- กลุ่มบุคคลที่เปราะบางและอ่อนแอ (vulnerable subjects) -->
                        <v-layout mt-6 ml-12>
                          <v-flex class="text-start font-weight-bold mb-2">
                            <span
                              >กลุ่มบุคคลที่เปราะบางและอ่อนแอ (vulnerable
                              subjects)</span
                            >
                          </v-flex>
                        </v-layout>
                        <v-layout style="margin-left: 70px" mt-2>
                          <v-flex class="text-start">
                            <v-radio-group
                              :readonly="isRead"
                              v-model="form.vulnerableSubject"
                              @change="updateData('vulnerableSubject', $event)"
                              row
                            >
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 40px"
                                label="เหมาะสม"
                                value="1"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 40px"
                                label="ไม่เหมาะสม"
                                value="2"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                label="ไม่มี"
                                value="3"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>

                        <!-- เอกสารการให้ความยินยอมของอาสาสมัครที่เป็นเด็กอายุ 7 ปีขึ้นไป แต่น้อยกว่า 18 ปี (assent form) -->
                        <v-layout mt-6 ml-12>
                          <v-flex class="text-start font-weight-bold mb-2">
                            <span
                              >เอกสารการให้ความยินยอมของอาสาสมัครที่เป็นเด็กอายุ
                              7 ปีขึ้นไป แต่น้อยกว่า 18 ปี (assent form)</span
                            >
                          </v-flex>
                        </v-layout>
                        <v-layout style="margin-left: 70px" mt-2>
                          <v-flex class="text-start">
                            <v-radio-group
                              :readonly="isRead"
                              v-model="form.assentForm"
                              @change="updateData('assentForm', $event)"
                              row
                            >
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 40px"
                                label="เหมาะสม"
                                value="1"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 40px"
                                label="ไม่เหมาะสม"
                                value="2"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 40px"
                                label="ไม่มี"
                                value="3"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                label="ไม่่เกี่ยวข้อง"
                                value="4"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <!-- End Form -->
                  </v-card>
                  <!--End Card 2 -->

                  <!--form ro03 3-->
                  <v-card
                    v-if="
                      (isCheckbox12.checkbox1 || isCheckbox12.checkbox2) &&
                        (!isRead || ro03_3FilePath)
                    "
                    class="mb-12"
                  >
                    <div>
                      <v-layout py-6 style="background-color: #3e7662">
                        <v-flex
                          style="
                            font-weight: bold;
                            font-size: 20px;
                            color: white;
                          "
                        >
                          <span
                            >แนวทางการทบทวนและนาเสนอโครงร่างการวิจัยเคร่ืองมือแพทย์
                            (RO 03_3_2563)</span
                          >
                        </v-flex>
                      </v-layout>
                      <div class="py-12">
                        <v-layout class="justify-center" v-if="!isRead">
                          <v-flex
                            shrink
                            pt-2
                            pr-4
                            style="text-align: left"
                            class="align-center justify-end d-flex"
                          >
                            <span style="font-weight: bold; font-size: 16px"
                              >ไฟล์</span
                            >
                          </v-flex>
                          <v-flex xs4 class="align-center d-flex">
                            <v-file-input
                              accept=".pdf"
                              prepend-icon=""
                              id="ro03_3File"
                              :model="form.ro03_3File"
                              outlined
                              dense
                              placeholder="Choose file"
                              background-color="#FBF6F3"
                              color="#3E7662"
                              item-color="#3E7662"
                              @change="onUploadFile('ro03_3File', $event)"
                              hide-details
                            ></v-file-input>
                          </v-flex>
                          <v-flex shrink pl-4 style="text-align: left">
                            <v-btn
                              color="#3E7662"
                              dark
                              @click="onHandleBtn('ro03_3File')"
                            >
                              <v-icon class="pr-3">cloud_download</v-icon>
                              <span>Upload</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-layout
                          class="justify-center"
                          mt-1
                          v-if="ro03_3FilePath"
                        >
                          <v-flex style="font-size: 18px; color: #cc3d45">
                            <span>ชื่อไฟล์ที่อัพโหลด : </span>
                            <a :href="ro03_3FilePath">{{ form.ro03_3File }}</a>
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                  </v-card>
                  <!--form ro04 2-->
                  <v-card
                    v-if="
                      (isCheckbox13.checkbox1 || isCheckbox13.checkbox2) &&
                        (!isRead || ro04_2FilePath)
                    "
                    class="mb-12"
                  >
                    <div>
                      <v-layout py-6 style="background-color: #3e7662">
                        <v-flex
                          style="
                            font-weight: bold;
                            font-size: 20px;
                            color: white;
                          "
                        >
                          <span
                            >แนวทางการทบทวนและนาเสนอเอกสารชี้แจงข้อมูลแก่อาสาสมัครในโครงการวิจัยเกี่ยวกับมนุษยพันธ์ุศาสตร์/วัตถุชีวภาพ
                          </span>
                        </v-flex>
                      </v-layout>
                      <div class="py-12">
                        <v-layout class="justify-center py-12" v-if="!isRead">
                          <v-flex
                            shrink
                            pt-2
                            pr-4
                            style="text-align: left"
                            class="align-center justify-end d-flex"
                          >
                            <span style="font-weight: bold; font-size: 16px"
                              >ไฟล์</span
                            >
                          </v-flex>
                          <v-flex xs4 class="align-center d-flex">
                            <v-file-input
                              accept=".pdf"
                              prepend-icon=""
                              id="ro04_2File"
                              :model="form.ro04_2File"
                              outlined
                              dense
                              placeholder="Choose file"
                              background-color="#FBF6F3"
                              color="#3E7662"
                              item-color="#3E7662"
                              @change="onUploadFile('ro04_2File', $event)"
                              hide-details
                            ></v-file-input>
                          </v-flex>
                          <v-flex shrink pl-4 style="text-align: left">
                            <v-btn
                              color="#3E7662"
                              dark
                              @click="onHandleBtn('ro04_2File')"
                            >
                              <v-icon class="pr-3">cloud_download</v-icon>
                              <span>Upload</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-layout
                          class="justify-center"
                          mt-1
                          v-if="ro04_2FilePath"
                        >
                          <v-flex style="font-size: 18px; color: #cc3d45">
                            <span>ชื่อไฟล์ที่อัพโหลด : </span>
                            <a :href="ro04_2FilePath">{{ form.ro04_2File }}</a>
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                  </v-card>

                  <!-- Start Card 4 -->
                  <v-card>
                    <div
                      v-if="
                        researchType === 'Full Board' ||
                          researchType === 'Full Board (แก้ไขเพื่อรับรอง)'
                      "
                    >
                      <!-- header กรณีพิจารณาแบบ Full Board -->
                      <v-layout py-6 style="background-color: #3e7662">
                        <v-flex
                          style="
                            font-weight: bold;
                            font-size: 20px;
                            color: white;
                          "
                        >
                          <span>กรณีพิจารณาแบบ Full Board</span>
                        </v-flex>
                      </v-layout>

                      <!-- Sumary -->
                      <v-layout style="padding: 20px 100px">
                        <v-flex>
                          <!-- สรุปความเห็น -->
                          <v-layout mt-6>
                            <v-flex class="text-start font-weight-bold mb-2">
                              <span>สรุปความเห็น</span>
                            </v-flex>
                          </v-layout>
                          <v-layout mt-2 ml-6>
                            <v-flex class="text-start">
                              <v-radio-group
                                :readonly="isRead"
                                v-model="form.fullBoardSummary"
                                @change="updateData('fullBoardSummary', $event)"
                              >
                                <v-radio
                                  color="#3E7662"
                                  style="
                                    padding-right: 40px;
                                    margin-bottom: 20px;
                                  "
                                  label="รับรอง"
                                  value="1"
                                ></v-radio>
                                <v-radio
                                  color="#3E7662"
                                  style="
                                    padding-right: 40px;
                                    margin-bottom: 20px;
                                  "
                                  label="ปรับปรุงแก้ไข เพื่อรับรอง"
                                  value="2"
                                ></v-radio>
                                <v-radio
                                  color="#3E7662"
                                  style="
                                    padding-right: 40px;
                                    margin-bottom: 20px;
                                  "
                                  label="ปรับปรุงแก้ไขและนำเข้าพิจารณาใหม่"
                                  value="3"
                                ></v-radio>
                                <v-radio
                                  color="#3E7662"
                                  label="ไม่รับรอง"
                                  value="4"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                          </v-layout>

                          <!-- กำหนดการส่งรายงานความก้าวหน้าของการวิจัย -->
                          <v-layout mt-6>
                            <v-flex class="text-start font-weight-bold mb-2">
                              <span
                                >กำหนดการส่งรายงานความก้าวหน้าของการวิจัย</span
                              >
                            </v-flex>
                          </v-layout>
                          <v-layout mt-2 ml-6>
                            <v-flex class="text-start">
                              <v-radio-group
                                :readonly="isRead"
                                v-model="form.fullBoardDeadline"
                                @change="
                                  updateData('fullBoardDeadline', $event)
                                "
                                row
                              >
                                <v-radio
                                  @click="form.fullBoardOtherDeadline = ''"
                                  color="#3E7662"
                                  style="padding-right: 40px"
                                  label="6 เดือน"
                                  value="1"
                                ></v-radio>
                                <v-radio
                                  @click="form.fullBoardOtherDeadline = ''"
                                  color="#3E7662"
                                  style="padding-right: 40px"
                                  label="1 ปี"
                                  value="2"
                                ></v-radio>
                                <v-radio
                                  color="#3E7662"
                                  label="อื่นๆ ระบุ"
                                  value="3"
                                ></v-radio>
                                <v-text-field
                                  :disabled="form.fullBoardDeadline !== '3'"
                                  color="#3E7662"
                                  class="mt-n3"
                                  v-model="form.fullBoardOtherDeadline"
                                  :readonly="isRead"
                                  hide-details
                                  @change="
                                    updateData('fullBoardOtherDeadline', $event)
                                  "
                                />
                              </v-radio-group>
                            </v-flex>
                          </v-layout>

                          <!-- แนะนำให้พบ -->
                          <v-layout mt-6>
                            <v-flex class="text-start font-weight-bold mb-2">
                              <span>แนะนำให้พบ</span>
                            </v-flex>
                          </v-layout>
                          <v-layout mt-2 ml-6>
                            <v-flex class="text-start">
                              <v-radio-group
                                :readonly="isRead"
                                v-model="form.fullBoardRecommendToMeet"
                                @change="
                                  updateData('fullBoardRecommendToMeet', $event)
                                "
                              >
                                <v-radio
                                  @click="form.fullBoardExpertConsultant = ''"
                                  color="#3E7662"
                                  style="
                                    padding-right: 40px;
                                    margin-bottom: 20px;
                                  "
                                  label="ไม่ต้องพบที่ปรึกษา"
                                  value="1"
                                ></v-radio>
                                <v-radio
                                  @click="form.fullBoardExpertConsultant = ''"
                                  color="#3E7662"
                                  style="padding-right: 40px"
                                  label="ผู้ทบทวน (Reviewer)"
                                  value="2"
                                ></v-radio>
                                <v-row>
                                  <v-col cols="auto">
                                    <v-radio
                                      color="#3E7662"
                                      label="ผู้เชี่ยวชาญ (Expert consultant) ระบุ"
                                      value="3"
                                    ></v-radio>
                                  </v-col>
                                  <v-col style="flex: 1; padding-left: 0">
                                    <v-text-field
                                      :disabled="
                                        form.fullBoardRecommendToMeet !== '3'
                                      "
                                      color="#3E7662"
                                      class="mt-n4"
                                      v-model="form.fullBoardExpertConsultant"
                                      @change="
                                        updateData(
                                          'fullBoardExpertConsultant',
                                          $event
                                        )
                                      "
                                      :readonly="isRead"
                                      hide-details
                                    />
                                  </v-col>
                                </v-row>
                              </v-radio-group>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                    <div v-else>
                      <v-layout py-6 style="background-color: #3e7662">
                        <v-flex
                          style="
                            font-weight: bold;
                            font-size: 20px;
                            color: white;
                          "
                        >
                          <span>กรณีพิจารณาแบบ Expedited review</span>
                        </v-flex>
                      </v-layout>
                      <!-- Sumary -->
                      <v-layout
                        style="
                          padding-left: 100px;
                          padding-right: 100px;
                          padding-top: 50px;
                          padding-bottom: 50px;
                        "
                      >
                        <v-flex>
                          <!-- สรุปความเห็น -->
                          <v-layout mt-6>
                            <v-flex class="text-start font-weight-bold mb-2">
                              <span>สรุปความเห็น</span>
                            </v-flex>
                          </v-layout>
                          <v-layout mt-2 ml-6>
                            <v-flex class="text-start">
                              <v-radio-group
                                :readonly="isRead"
                                v-model="form.expeditedSummary"
                                @change="updateData('expeditedSummary', $event)"
                                row
                              >
                                <v-radio
                                  color="#3E7662"
                                  style="padding-right: 40px"
                                  label="รับรอง"
                                  value="1"
                                ></v-radio>
                                <v-radio
                                  color="#3E7662"
                                  style="padding-right: 40px"
                                  label="ปรับปรุงแก้ไข เพื่อรับรอง"
                                  value="2"
                                ></v-radio>
                                <v-radio
                                  color="#3E7662"
                                  label="นำเข้าพิจารณาใน Full Board"
                                  value="3"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                          </v-layout>

                          <!-- กำหนดการส่งรายงานความก้าวหน้าของการวิจัย -->
                          <v-layout mt-6>
                            <v-flex class="text-start font-weight-bold mb-2">
                              <span
                                >กำหนดการส่งรายงานความก้าวหน้าของการวิจัย</span
                              >
                            </v-flex>
                          </v-layout>
                          <v-layout mt-2 ml-6>
                            <v-flex class="text-start">
                              <v-radio-group
                                :readonly="isRead"
                                v-model="form.expeditedDeadline"
                                @change="
                                  updateData('expeditedDeadline', $event)
                                "
                                row
                              >
                                <v-radio
                                  @click="form.expeditedOtherDeadline = ''"
                                  color="#3E7662"
                                  style="padding-right: 40px"
                                  label="6 เดือน"
                                  value="1"
                                ></v-radio>
                                <v-radio
                                  @click="form.expeditedOtherDeadline = ''"
                                  color="#3E7662"
                                  style="padding-right: 40px"
                                  label="1 ปี"
                                  value="2"
                                ></v-radio>
                                <v-radio
                                  color="#3E7662"
                                  label="อื่นๆ ระบุ"
                                  value="3"
                                ></v-radio>
                                <v-text-field
                                  :disabled="form.expeditedDeadline !== '3'"
                                  color="#3E7662"
                                  class="mt-n3"
                                  v-model="form.expeditedOtherDeadline"
                                  @change="
                                    updateData('expeditedOtherDeadline', $event)
                                  "
                                  :readonly="isRead"
                                  hide-details
                                />
                              </v-radio-group>
                            </v-flex>
                          </v-layout>

                          <!-- แนะนำให้พบ -->
                          <v-layout mt-6>
                            <v-flex class="text-start font-weight-bold mb-2">
                              <span>แนะนำให้พบ</span>
                            </v-flex>
                          </v-layout>
                          <v-layout mt-2 ml-6>
                            <v-flex class="text-start">
                              <v-radio-group
                                :readonly="isRead"
                                v-model="form.expeditedRecommendToMeet"
                                @change="
                                  updateData('expeditedRecommendToMeet', $event)
                                "
                              >
                                <v-radio
                                  @click="form.expeditedExpertConsultant = ''"
                                  color="#3E7662"
                                  style="
                                    padding-right: 40px;
                                    margin-bottom: 20px;
                                  "
                                  label="ไม่ต้องพบที่ปรึกษา"
                                  value="1"
                                ></v-radio>
                                <v-radio
                                  @click="form.expeditedExpertConsultant = ''"
                                  color="#3E7662"
                                  style="padding-right: 40px"
                                  label="ผู้ทบทวน (Reviewer)"
                                  value="2"
                                ></v-radio>
                                <v-row>
                                  <v-col cols="auto">
                                    <v-radio
                                      color="#3E7662"
                                      label="ผู้เชี่ยวชาญ (Expert consultant) ระบุ"
                                      value="3"
                                    ></v-radio>
                                  </v-col>
                                  <v-col style="flex: 1; padding-left: 0">
                                    <v-text-field
                                      :disabled="
                                        form.expeditedRecommendToMeet !== '3'
                                      "
                                      color="#3E7662"
                                      class="mt-n4"
                                      v-model="form.expeditedExpertConsultant"
                                      @change="
                                        updateData(
                                          'expeditedExpertConsultant',
                                          $event
                                        )
                                      "
                                      :readonly="isRead"
                                      hide-details
                                    />
                                  </v-col>
                                </v-row>
                              </v-radio-group>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                    <!-- ผู้ประเมิน -->
                    <div style="padding: 20px 100px">
                      <v-layout mt-6>
                        <v-flex
                          xs1
                          mt-4
                          mr-2
                          class="font-weight-bold d-flex justify-end align-center"
                        >
                          ผู้ประเมิน
                        </v-flex>
                        <v-flex xs4 class="text-start text-field-center">
                          <v-text-field
                            hide-details
                            v-model="form.signature"
                            :readonly="isRead"
                            color="#3E7662"
                            append-icon="edit"
                          />
                        </v-flex>
                        <v-flex
                          xs1
                          mt-4
                          mr-2
                          class="d-flex justify-end font-weight-bold d-flex align-center"
                        >
                          คนที่
                        </v-flex>
                        <v-flex xs1 class="text-start text-field-center">
                          <v-text-field
                            hide-details
                            v-model="form.order"
                            :readonly="isRead"
                            color="#3E7662"
                          />
                        </v-flex>
                      </v-layout>
                      <!-- Date -->
                      <v-layout mt-8>
                        <v-flex xs3>
                          <DateInputForm
                            :model="dateChange"
                            :readonly="isRead"
                            @update-data="updateDate('estimateDate', $event)"
                          />
                        </v-flex>
                      </v-layout>
                    </div>
                    <v-layout class="pl-12 pb-12">
                      <v-flex class="text-start font-weight-bold">
                        <span
                          >สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-card>
                  <!--End Card 4 -->
                </v-form>

                <!-- Start Form -->
                <!-- Button Save -->
                <v-layout mt-8>
                  <v-flex mb-12 style="text-align: right">
                    <v-layout>
                      <v-flex>
                        <v-btn
                          style="color: #3e7662"
                          depressed
                          color="#ffffff"
                          @click="$router.go(-1)"
                          >ย้อนกลับ
                        </v-btn>
                        <v-btn
                          class="ml-4"
                          v-if="(!isRead && !isSubmit) || isStaff"
                          depressed
                          :dark="valid"
                          color="#3E7662"
                          @click="save(0)"
                          :disabled="!valid"
                        >
                          <span>บันทึกข้อมูล</span>
                        </v-btn>
                        <v-btn
                          class="ml-4"
                          v-if="(!isRead && !isSubmit) || isStaff"
                          depressed
                          :dark="valid"
                          color="#3E7662"
                          @click="save(1)"
                          :disabled="!valid"
                        >
                          <span>บันทึกข้อมูลและส่งการประเมิน</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-pageAndLine="false"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";
import axios from "axios";
import { domain } from "../../services/Constants";

export default {
  name: "FormRO02",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  data: () => ({
    detail: false,
    requireRules: [(v) => !!v || "field is required"],
    valid: true,
    isLoading: false,
    fullpageAndLine: true,
    printMode: false,
    form: {
      //check box 12
      checkbox12_1: false,
      checkbox12_2: false,
      checkbox12_3: false,
      checkbox12_4: false,
      checkbox12_5: false,
      checkbox12_6: false,
      checkbox12_7: false,
      checkbox12_8: false,
      checkbox12_9: false,
      checkbox12_10: false,
      checkbox12_11: false,
      checkbox12_12: false,
      checkbox12_13: false,
      checkbox12_14: false,
      checkbox12_15: false,
      checkbox12_16: false,
      checkbox12_17: false,
      checkbox12_18: false,
      //check box 13
      checkbox13_1: false,
      checkbox13_2: false,
      checkbox13_3: false,
      checkbox13_4: false,
      checkbox13_5: false,
      checkbox13_6: false,
      checkbox13_7: false,
      checkbox13_8: false,
      checkbox13_9: false,
      checkbox13_10: false,
      checkbox13_11: false,
      checkbox13_12: false,
      checkbox13_13: false,
      checkbox13_14: false,
      checkbox13_15: false,
      checkbox13_16: false,
      checkbox13_17: false,
      checkbox13_18: false,
      checkbox13_19: false,
      checkbox13_20: false,
      checkbox13_21: false,
      checkbox13_22: false,
      checkbox13_23: false,
      checkbox13_24: false,
      checkbox13_25: false,
      checkbox13_26: false,
      checkbox13_27: false,
      checkbox13_28: false,
      checkbox13_29: false,
      checkbox13_30: false,
      checkbox13_31: false,
      checkbox13_32: false,
      checkbox13_33: false,
      checkbox13_34: false,
      checkbox13_35: false,
      checkbox13_36: false,
      checkbox13_37: false,
      //check box 19
      checkbox19_1: false,
      checkbox19_2: false,
      checkbox19_3: false,
      checkbox19_4: false,
      checkbox19_5: false,
      checkbox19_6: false,
      checkbox19_7: false,
      checkbox19_8: false,
      checkbox19_9: false,
      checkbox19_10: false,

      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      isAppropriate1: "",
      advice1: "",
      isAppropriate2: "",
      advice2: "",
      isAppropriate3: "",
      advice3: "",
      isAppropriate4: "",
      advice4: "",
      isAppropriate5: "",
      advice5: "",
      isAppropriate6: "",
      advice6: "",
      isAppropriate7: "",
      advice7: "",
      isAppropriate8: "",
      advice8: "",
      isAppropriate9: "",
      advice9: "",
      isAppropriate10: "",
      advice10: "",
      isAppropriate11: "",
      advice11: "",
      isAppropriate12: "",
      advice12: "",
      isAppropriate13: "",
      advice13: "",
      isAppropriate14: "",
      advice14: "",
      isAppropriate14_1: "",
      advice14_1: "",
      isAppropriate14_2: "",
      advice14_2: "",
      isAppropriate15: "",
      advice15: "",
      isAppropriate16: "",
      advice16: "",
      isAppropriate17: "",
      advice17: "",
      isAppropriate18: "",
      advice18: "",
      isAppropriate19: "",
      advice19: "",
      isAppropriate19_1: "",
      advice19_1: "",
      isAppropriate19_2: "",
      advice19_2: "",
      isAppropriate20: "",
      advice20: "",
      isAppropriate20_1: "",
      advice20_1: "",
      isAppropriate20_2: "",
      advice20_2: "",
      isAppropriate20_3: "",
      advice20_3: "",
      isAppropriate20_4: "",
      advice20_4: "",
      isAppropriate21: "",
      advice21: "",
      isAppropriate22: "",
      advice22: "",
      isAppropriate23: "",
      advice23: "",
      isAppropriate23_1: "",
      advice23_1: "",
      isAppropriate23_2: "",
      advice23_2: "",
      isAppropriate24: "",
      advice24: "",
      isAppropriate25: "",
      advice25: "",
      isAppropriate25_1: "",
      advice25_1: "",
      isAppropriate26: "",
      advice26: "",
      isAppropriate26_1: "",
      advice26_1: "",
      isAppropriate26_2: "",
      advice26_2: "",
      isAppropriate26_3: "",
      advice26_3: "",
      isAppropriate26_4: "",
      advice26_4: "",
      isAppropriate26_5: "",
      advice26_5: "",
      isAppropriate26_6: "",
      advice26_6: "",
      isAppropriate27: "",
      advice27: "",
      isAppropriate28: "",
      advice28: "",
      isAppropriate29: "",
      advice29: "",
      isAppropriate30: "",
      advice30: "",
      isAppropriate31: "",
      advice31: "",
      isAppropriate32: "",
      advice32: "",
      isAppropriate33: "",
      advice33: "",
      isAppropriate33_1: "",
      advice33_1: "",
      isAppropriate33_2: "",
      advice33_2: "",
      isAppropriate34: "",
      advice34: "",
      isAppropriate35: "",
      advice35: "",
      isAppropriate36: "",
      advice36: "",
      isAppropriate37: "",
      advice37: "",
      isAppropriate38: "",
      advice38: "",
      isAppropriate39: "",
      advice39: "",
      isAppropriate40: "",
      advice40: "",
      isAppropriate41: "",
      advice41: "",
      isAppropriate42: "",
      advice42: "",
      isAppropriate43: "",
      advice43: "",
      //ข้อ19
      isAppropriate44: "",
      advice44: "",
      adviceResearch: "",
      adviceProcess: "",
      adviceDoc: "",
      adviceResearcher: "",
      adviceEthical: "",
      riskRatio: "",
      riskCategories: "",
      vulnerableSubject: "",
      assentForm: "",
      expeditedSummary: "",
      expeditedDeadline: "",
      expeditedOtherDeadline: "",
      expeditedRecommendToMeet: "",
      expeditedExpertConsultant: "",
      fullBoardSummary: "",
      fullBoardDeadline: "",
      fullBoardOtherDeadline: "",
      fullBoardRecommendToMeet: "",
      fullBoardExpertConsultant: "",
      signature: "",
      order: "",
      estimateDate: "",
      isCognitive: false,
      isInstitutional: false,
      isDeferral: false,
      isMedical: false,
      isEconomic: false,
      isSocial: false,
      isOtherAnswer: false,
      // ro03_3File: "",
      // ro04_2File: "",
    },
    isCheckbox1: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox2: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox3: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox4: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox5: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox6: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox7: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox8: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox9: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox10: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox11: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox12: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox13: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox14: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox14_1: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox14_2: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox15: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox16: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox17: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox18: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox19: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox19_1: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox19_2: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox20: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox20_1: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox20_2: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox20_3: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox20_4: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox21: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox22: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox23: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox23_1: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox23_2: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox24: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox25: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox25_1: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox26: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox26_1: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox26_2: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox26_3: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox26_4: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox26_5: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox26_6: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox27: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox28: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox29: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox30: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox31: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox32: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox33: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox33_1: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox33_2: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox34: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox35: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox36: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox37: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox38: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox39: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox40: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox41: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox42: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox43: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox44: { checkbox1: false, checkbox2: false, checkbox3: false },
    dateChange: "",
    researchType: "",
    isRead: false,
    lastKey: "",
    lastValue: "",
    isSubmit: false,
    isStaff: false,
    // ro03_3FilePath: "",
    // ro04_2FilePath: "",
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    // Check Permission Access
    if (this.user.currentRole === 1) {
      this.isStaff = true;
    }
    this.updateDate("estimateDateGet", new Date().toISOString().substr(0, 10));
    this.form.order = this.$route.query.order;
    this.form.signature = this.$route.query.reviewerName;
    //change from login user to the reviewer name
    // this.form.signature = this.user.thName;
    this.form.researchName = this.$route.query.nameResearch;
    this.form.firstName = this.$route.query.mainResearcherFirstName;
    this.form.lastName = this.$route.query.mainResearcherLastName;
    this.form.researchCode = this.$route.query.researchCode;
    this.researchType = this.$route.query.researchType;
    this.isRead = this.$route.query.isRead === "true";

    // this.updateDate("estimateDate", {
    //   date: new Date().toISOString().substr(0, 10),
    // });

    this.getRO03_1();
  },

  methods: {
    async printPage() {
      this.printMode = true;
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
        "#fff";
      await document.querySelectorAll("button").forEach(function(element) {
        element.style.display = "none";
      });
      await document.querySelectorAll(".v-icon").forEach(function(element) {
        element.style.display = "none";
      });
      await document
        .getElementsByClassName("v-input--checkbox v-input--is-label-active")
        .forEach(function(element) {
          element.innerHTML = "✓" + element.innerHTML;
        });
      await document
        .getElementsByClassName("v-radio v-item--active")
        .forEach(function(element) {
          element.innerHTML = "✓ " + element.innerHTML;
        });
      var node = document.getElementById("print");
      var self = this;
      domtoimage
        .toPng(node)
        .then(async function(dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          var page = self.imageToPrint(img);

          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(page);
          pwa.document.close();
          self.printMode = false;
          await document.querySelectorAll("button").forEach(function(element) {
            element.style.display = "unset";
          });
          await document
            .getElementsByClassName(
              "v-input--checkbox v-input--is-label-active"
            )
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓", "");
            });
          await document
            .getElementsByClassName("v-radio v-item--active")
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓ ", "");
            });
          await document.querySelectorAll(".v-icon").forEach(function(element) {
            element.style.display = "unset";
          });
          document
            .getElementsByClassName("print-form")[0]
            .removeAttribute("style");
        })
        .catch(function(error) {
          Swal.fire({
            title: "กรุณาเปิดการอนุญาต Pop Up!",
            description: "",
            icon: "error",
            confirmButtonColor: "#3E7662",
            cancelButtonColor: "rgb(189, 189, 189)",
            confirmButtonText: "ตกลง",
          }).then(async function() {
            await document
              .querySelectorAll("button")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            await document
              .getElementsByClassName(
                "v-input--checkbox v-input--is-label-active"
              )
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓", "");
              });
            await document
              .getElementsByClassName("v-radio v-item--active")
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓ ", "");
              });
            await document
              .querySelectorAll(".v-icon")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            document
              .getElementsByClassName("print-form")[0]
              .removeAttribute("style");
          });
        });
    },
    imageToPrint(source) {
      return (
        "<html><body onload='window.print()'><style>@media print {\n" +
        "  @page { margin: 0; }\n" +
        "  html, body {\n" +
        "    margin: 0;\n" +
        "    width: 210mm;\n" +
        "    height: 297mm;\n" +
        "  }\n" +
        "  img {\n" +
        "    margin-top: 10mm;\n" +
        "    margin-left: 20mm;\n" +
        "    width: 170mm;\n" +
        // "    height: 297mm;\n" +
        "  }\n" +
        "}</style>" +
        source.outerHTML +
        "</body></html>"
      );
    },
    replaceWithBr(text) {
      if (text) return text.replace(/\n/g, "<br/>");
      return "";
    },
    updateData(name, val) {
      this.form[name] = val;
      let previousKey = this.lastKey;
      if (previousKey !== name || val.length == 1) {
        this.autoSave();
      }
      this.lastKey = name;
      this.lastValue = val;
    },
    updateDate(name, val) {
      if (name === "estimateDate") {
        this.form.estimateDate = val.date;
        this.dateChange = this.changeDate(val.date);
      }
      if (name === "estimateDateGet") {
        this.form.estimateDate = val;
        this.dateChange = this.changeDate(val);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    clearRadio(val, name) {
      if (name === "expeditedDeadline") {
        if (val !== 3) {
          this.form.expeditedDeadline = val.toString();
          this.form.expeditedOtherDeadline = "";
        }
      }
      if (name === "expeditedRecommendToMeet") {
        if (val !== 3) {
          this.form.expeditedRecommendToMeet = val.toString();
          this.form.expeditedExpertConsultant = "";
        }
      }
      if (name === "fullBoardDeadline") {
        if (val !== "3") {
          this.form.fullBoardDeadline = val.toString();
          this.form.fullBoardOtherDeadline = "";
        }
      }
      if (name === "fullBoardRecommendToMeet") {
        if (val !== "3") {
          this.form.fullBoardRecommendToMeet = val.toString();
          this.form.fullBoardExpertConsultant = "";
        }
      }
    },
    checkbox(val, no, name) {
      for (let i = 1; i <= 3; i++) {
        this[
          `isCheckbox${
            name.length === 14
              ? name.slice(-1)
              : name.length === 15
              ? name.slice(-2)
              : name.slice(-4)
          }`
        ][`checkbox${i}`] = false;
      }
      this[
        `isCheckbox${
          name.length === 14
            ? name.slice(-1)
            : name.length === 15
            ? name.slice(-2)
            : name.slice(-4)
        }`
      ][`checkbox${no}`] = val;
      // this.form[name] = no;
      this.updateData(name, no);
    },
    checkboxGet(no, name) {
      for (let i = 1; i <= 3; i++) {
        this[
          `isCheckbox${
            name.length === 14
              ? name.slice(-1)
              : name.length === 15
              ? name.slice(-2)
              : name.slice(-4)
          }`
        ][`checkbox${i}`] = false;
      }
      this[
        `isCheckbox${
          name.length === 14
            ? name.slice(-1)
            : name.length === 15
            ? name.slice(-2)
            : name.slice(-4)
        }`
      ][`checkbox${no}`] = true;
      this.form[name] = no;
    },
    setCheckbox(val, name) {
      for (let i = 1; i <= 3; i++) {
        this[
          `isCheckbox${name.length === 14 ? name.slice(-1) : name.slice(-2)}`
        ][`checkbox${i}`] = false;
      }
      this[`isCheckbox${name.length === 14 ? name.slice(-1) : name.slice(-2)}`][
        `checkbox${val}`
      ] = val;
      this.form[name] = val;
    },
    save(isSend) {
      if (this.validateField() === true || !isSend) {
        Swal.fire({
          title: isSend
            ? "คุณต้องการส่งแบบประเมินหรือไม่?"
            : "คุณต้องการบันทึกหรือไม่?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3E7662",
          cancelButtonColor: "rgb(189, 189, 189)",
          confirmButtonText: "ใช่",
        }).then((result) => {
          if (result.value) {
            this.isLoading = true;
            this.form["researchID"] = this.$route.query.id;
            this.form["isSubmit"] = isSend;
            this.$store
              .dispatch("FormRO/saveRO03_1", this.form)
              .then((res) => {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "บันทึกสำเร็จ",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(() => {
                  this.$router.go(-1);
                });
                this.isLoading = false;
              })
              .catch((e) => {
                this.isLoading = false;
                if (e.response.data.errors) {
                  for (var k in e.response.data.errors) {
                    Swal.fire({
                      title: "เกิดข้อผิดพลาด",
                      text: e.response.data.errors[k][0],
                      icon: "warning",
                      confirmButtonColor: "#3E7662",
                    }).then(() => {
                      this.$vuetify.goTo(`#${k}`);
                    });
                  }
                } else {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.message,
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  });
                }
              });
          }
        });
      }
    },
    autoSave() {
      if (this.isSubmit) {
        return false;
      }
      let payload = {
        researchID: this.$route.query.id,
        isSubmit: 0,
        order: this.$route.query.order,
      };
      (payload[this.lastKey] = this.lastValue),
        this.$store.dispatch("FormRO/saveRO03_1", payload).catch((e) => {
          if (e.response.data.errors) {
            for (var k in e.response.data.errors) {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: e.response.data.errors[k][0],
                icon: "warning",
                confirmButtonColor: "#3E7662",
              }).then(() => {
                this.$vuetify.goTo(`#${k}`);
              });
            }
          } else {
            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              text: e.response.message,
              icon: "warning",
              confirmButtonColor: "#3E7662",
            });
          }
        });
    },
    validateField() {
      if (!this.form.researchCode) {
        Swal.fire({
          title: "ใบตอบรับเอกสาร Receipt",
          text: "กรุณาระบุ รหัสโครงร่างการวิจัย",
          icon: "warning",
        });
        return false;
      } else if (!this.form.firstName) {
        Swal.fire({
          title: "ใบตอบรับเอกสาร Receipt",
          text: "กรุณาระบุ ชื่อผู้วิจัยหลัก",
          icon: "warning",
        });
        return false;
      } else if (!this.form.lastName) {
        Swal.fire({
          title: "ใบตอบรับเอกสาร Receipt",
          text: "กรุณาระบุ นามสกุล",
          icon: "warning",
        });
        return false;
      } else if (!this.form.researchName) {
        Swal.fire({
          title: "ใบตอบรับเอกสาร Receipt",
          text: "กรุณาระบุ ชื่อโครงการวิจัย (ไทย)",
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox1.checkbox1 &&
        !this.isCheckbox1.checkbox2 &&
        !this.isCheckbox1.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก โครงร่างการวิจัยที่แก้ไขตามข้อแนะนํา`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox2.checkbox1 &&
        !this.isCheckbox2.checkbox2 &&
        !this.isCheckbox2.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การทบทวนวรรณกรรมที่เกี่ยวข้อง ICH-GCP 6.2.7`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox3.checkbox1 &&
        !this.isCheckbox3.checkbox2 &&
        !this.isCheckbox3.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วัตถุประสงค์ (Objective) ICH-GCP 6.3`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox4.checkbox1 &&
        !this.isCheckbox4.checkbox2 &&
        !this.isCheckbox4.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก รูปแบบการวิจัย (Study design) ICH-GCP 6.4`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox5.checkbox1 &&
        !this.isCheckbox5.checkbox2 &&
        !this.isCheckbox5.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก กลุ่มประชากรที่ศึกษา (Study population) ICH-GCP 6.2.6`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox6.checkbox1 &&
        !this.isCheckbox6.checkbox2 &&
        !this.isCheckbox6.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ขนาดตัวอย่าง (Sample size) ICH-GCP 6.9.2`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox7.checkbox1 &&
        !this.isCheckbox7.checkbox2 &&
        !this.isCheckbox7.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การคัดเลือกอาสาสมัครที่เข้าโครงการ (Inclusion criteria) ICH-GCP 6.5`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox8.checkbox1 &&
        !this.isCheckbox8.checkbox2 &&
        !this.isCheckbox8.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การคัดอาสาสมัครออกจากโครงการวิจัย (Exclusion criteria) ICH-GCP 6.5.3`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox9.checkbox1 &&
        !this.isCheckbox9.checkbox2 &&
        !this.isCheckbox9.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การถอนอาสาสมัครออกจากโครงการ (Withdrawal Criteria) ICH-GCP 6.4.6`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox10.checkbox1 &&
        !this.isCheckbox10.checkbox2 &&
        !this.isCheckbox10.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การใช้อาสาสมัครกลุ่มเปราะบาง`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox11.checkbox1 &&
        !this.isCheckbox11.checkbox2 &&
        !this.isCheckbox11.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การแบ่งกลุ่มอาสาสมัคร ICH-GCP 6.4.3`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox12.checkbox1 &&
        !this.isCheckbox12.checkbox2 &&
        !this.isCheckbox12.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก เครื่องมือหรือวิธีทดสอบที่ใช้ในการวิจัย ICH-GCP 6.6.1`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox13.checkbox1 &&
        !this.isCheckbox13.checkbox2 &&
        !this.isCheckbox13.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การใช้กลุ่มควบคุมหรือยาหลอก ICH-GCP 6.4.7`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox14.checkbox1 &&
        !this.isCheckbox14.checkbox2 &&
        !this.isCheckbox14.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วิธีการวัดผลการวิจัย ICH-GCP 6.4.1`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox14_1.checkbox1 &&
        !this.isCheckbox14_1.checkbox2 &&
        !this.isCheckbox14_1.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วิธีการวัดผลการวิจัย ICH-GCP 6.4.1`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox14_2.checkbox1 &&
        !this.isCheckbox14_2.checkbox2 &&
        !this.isCheckbox14_2.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วิธีการวัดผลการวิจัย ICH-GCP 6.4.1`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox15.checkbox1 &&
        !this.isCheckbox15.checkbox2 &&
        !this.isCheckbox15.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การเฝ้าระวังผลแทรกซ้อนและการแก้ไข ICH-GCP 6.8.1`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox16.checkbox1 &&
        !this.isCheckbox16.checkbox2 &&
        !this.isCheckbox16.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก จำนวนและปริมาณของเลือด/สิ่งส่งตรวจICH-GCP 6.7.1`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox17.checkbox1 &&
        !this.isCheckbox17.checkbox2 &&
        !this.isCheckbox17.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ระยะเวลา/จำนวนครั้งของการติดตาม ICH-GCP 6.4.5`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox18.checkbox1 &&
        !this.isCheckbox18.checkbox2 &&
        !this.isCheckbox18.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก สถิติที่ใช้ในการวิเคราะห์ ICH-GCP 6.9`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox19.checkbox1 &&
        !this.isCheckbox19.checkbox2 &&
        !this.isCheckbox19.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ความเสี่ยงต่อสุขภาพของอาสาสมัครโดยตรง`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox19_1.checkbox1 &&
        !this.isCheckbox19_1.checkbox2 &&
        !this.isCheckbox19_1.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ความเสี่ยงต่อสุขภาพของอาสาสมัครโดยตรง`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox19_2.checkbox1 &&
        !this.isCheckbox19_2.checkbox2 &&
        !this.isCheckbox19_2.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ความเสี่ยงต่อสุขภาพของอาสาสมัครโดยตรง`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox20.checkbox1 &&
        !this.isCheckbox20.checkbox2 &&
        !this.isCheckbox20.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ความเสี่ยงต่อสุขภาพของตัวอ่อนหรือบุตรในครรภ์หรือคู่สมรส`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox20_1.checkbox1 &&
        !this.isCheckbox20_1.checkbox2 &&
        !this.isCheckbox20_1.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ความเสี่ยงต่อสุขภาพของตัวอ่อนหรือบุตรในครรภ์หรือคู่สมรส`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox20_2.checkbox1 &&
        !this.isCheckbox20_2.checkbox2 &&
        !this.isCheckbox20_2.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ความเสี่ยงต่อสุขภาพของตัวอ่อนหรือบุตรในครรภ์หรือคู่สมรส`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox20_3.checkbox1 &&
        !this.isCheckbox20_3.checkbox2 &&
        !this.isCheckbox20_3.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ความเสี่ยงต่อสุขภาพของตัวอ่อนหรือบุตรในครรภ์หรือคู่สมรส`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox20_4.checkbox1 &&
        !this.isCheckbox20_4.checkbox2 &&
        !this.isCheckbox20_4.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ความเสี่ยงต่อสุขภาพของตัวอ่อนหรือบุตรในครรภ์หรือคู่สมรส`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox21.checkbox1 &&
        !this.isCheckbox21.checkbox2 &&
        !this.isCheckbox21.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ผลกระทบต่อจิตใจ ชื่อเสียง สังคมและเศรษฐกิจของอาสาสมัครโดยตรง`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox22.checkbox1 &&
        !this.isCheckbox22.checkbox2 &&
        !this.isCheckbox22.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ผลกระทบต่อชุมชนที่เข้าร่วมการวิจัย`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox23.checkbox1 &&
        !this.isCheckbox23.checkbox2 &&
        !this.isCheckbox23.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ประโยชน์ต่ออาสาสมัครโดยตรง`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox23_1.checkbox1 &&
        !this.isCheckbox23_1.checkbox2 &&
        !this.isCheckbox23_1.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ประโยชน์ต่ออาสาสมัครโดยตรง`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox23_2.checkbox1 &&
        !this.isCheckbox23_2.checkbox2 &&
        !this.isCheckbox23_2.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ประโยชน์ต่ออาสาสมัครโดยตรง`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox24.checkbox1 &&
        !this.isCheckbox24.checkbox2 &&
        !this.isCheckbox24.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ประโยชน์ต่อชุมชนที่เข้าร่วมการวิจัย`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox25.checkbox1 &&
        !this.isCheckbox25.checkbox2 &&
        !this.isCheckbox25.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ประโยชน์ต่อสังคม`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox25_1.checkbox1 &&
        !this.isCheckbox25_1.checkbox2 &&
        !this.isCheckbox25_1.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ประโยชน์ต่อสังคม`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox26.checkbox1 &&
        !this.isCheckbox26.checkbox2 &&
        !this.isCheckbox26.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วิธีการชักชวนอาสาสมัครเข้าสู่โครงการ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox26_1.checkbox1 &&
        !this.isCheckbox26_1.checkbox2 &&
        !this.isCheckbox26_1.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วิธีการชักชวนอาสาสมัครเข้าสู่โครงการ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox26_2.checkbox1 &&
        !this.isCheckbox26_2.checkbox2 &&
        !this.isCheckbox26_2.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วิธีการชักชวนอาสาสมัครเข้าสู่โครงการ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox26_3.checkbox1 &&
        !this.isCheckbox26_3.checkbox2 &&
        !this.isCheckbox26_3.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วิธีการชักชวนอาสาสมัครเข้าสู่โครงการ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox26_4.checkbox1 &&
        !this.isCheckbox26_4.checkbox2 &&
        !this.isCheckbox26_4.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วิธีการชักชวนอาสาสมัครเข้าสู่โครงการ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox26_5.checkbox1 &&
        !this.isCheckbox26_5.checkbox2 &&
        !this.isCheckbox26_5.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วิธีการชักชวนอาสาสมัครเข้าสู่โครงการ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox26_6.checkbox1 &&
        !this.isCheckbox26_6.checkbox2 &&
        !this.isCheckbox26_6.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วิธีการชักชวนอาสาสมัครเข้าสู่โครงการ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox27.checkbox1 &&
        !this.isCheckbox27.checkbox2 &&
        !this.isCheckbox27.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การแจ้งวัตถุประสงค์ของการวิจัย`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox28.checkbox1 &&
        !this.isCheckbox28.checkbox2 &&
        !this.isCheckbox28.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ระบุแหล่งทุนสนับสนุน`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox29.checkbox1 &&
        !this.isCheckbox29.checkbox2 &&
        !this.isCheckbox29.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ขั้นตอนการปฏิบัติตัวของอาสาสมัคร`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox30.checkbox1 &&
        !this.isCheckbox30.checkbox2 &&
        !this.isCheckbox30.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ระบุความเสี่ยงและผลแทรกซ้อน`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox31.checkbox1 &&
        !this.isCheckbox31.checkbox2 &&
        !this.isCheckbox31.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ประโยชน์ที่ได้รับจากการเข้าร่วมวิจัย`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox32.checkbox1 &&
        !this.isCheckbox32.checkbox2 &&
        !this.isCheckbox32.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การเข้าร่วมโครงการเป็นโดยสมัครใจ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox33.checkbox1 &&
        !this.isCheckbox33.checkbox2 &&
        !this.isCheckbox33.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ทางเลือกอื่นหากไม่เข้าร่วมโครงการ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox33_1.checkbox1 &&
        !this.isCheckbox33_1.checkbox2 &&
        !this.isCheckbox33_1.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ทางเลือกอื่นหากไม่เข้าร่วมโครงการ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox33_2.checkbox1 &&
        !this.isCheckbox33_2.checkbox2 &&
        !this.isCheckbox33_2.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ทางเลือกอื่นหากไม่เข้าร่วมโครงการ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox34.checkbox1 &&
        !this.isCheckbox34.checkbox2 &&
        !this.isCheckbox34.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก สิทธิในการถอนตัวจากโครงการวิจัย`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox35.checkbox1 &&
        !this.isCheckbox35.checkbox2 &&
        !this.isCheckbox35.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การจ่ายค่าตอบแทน/ค่าเดินทาง/ค่าใช้จ่าย/ค่าชดเชยแก่อาสาสมัคร`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox36.checkbox1 &&
        !this.isCheckbox36.checkbox2 &&
        !this.isCheckbox36.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก การเก็บรักษาความลับของอาสาสมัคร`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox37.checkbox1 &&
        !this.isCheckbox37.checkbox2 &&
        !this.isCheckbox37.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ชื่อ ที่อยู่และเบอร์โทรศัพท์ติดต่อผู้วิจัย`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox38.checkbox1 &&
        !this.isCheckbox38.checkbox2 &&
        !this.isCheckbox38.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ที่อยู่และเบอร์โทรศัพท์ติดต่อคณะกรรมการ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox39.checkbox1 &&
        !this.isCheckbox39.checkbox2 &&
        !this.isCheckbox39.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก วิธีการแสดงความยินยอมของอาสาสมัคร`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox40.checkbox1 &&
        !this.isCheckbox40.checkbox2 &&
        !this.isCheckbox40.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก พื้นฐานอาชีพและประสบการณ์ของผู้วิจัย`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox41.checkbox1 &&
        !this.isCheckbox41.checkbox2 &&
        !this.isCheckbox41.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก Conflict of interest`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox42.checkbox1 &&
        !this.isCheckbox42.checkbox2 &&
        !this.isCheckbox42.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ประวัติการอบรมจริยธรรมการวิจัยของผู้วิจัย และผู้ร่วมโครงการวิจัย`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.isCheckbox43.checkbox1 &&
        !this.isCheckbox43.checkbox2 &&
        !this.isCheckbox43.checkbox3
      ) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก  ประวัติการอบรมจริยธรรมการวิจัยของผู้วิจัย และผู้ร่วมโครงการวิจัย`,
          icon: "warning",
        });
        return false;
        // } else if (!this.form.adviceResearch) {
        //     Swal.fire({
        //         title: 'หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย',
        //         text: `กรุณาระบุ ข้อเสนอแนะเพิ่มเติมอื่นๆ`,
        //         icon: 'warning',
        //     });
        //     return false;
        // } else if (!this.form.adviceProcess) {
        //     Swal.fire({
        //         title: 'หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย',
        //         text: `กรุณาระบุ ข้อเสนอแนะเพิ่มเติมกระบวนการขอความยินยอม (Informed Consent Process)`,
        //         icon: 'warning',
        //     });
        //     return false;
        // } else if (!this.form.adviceDoc) {
        //     Swal.fire({
        //         title: 'หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย',
        //         text: `กรุณาระบุ ข้อเสนอแนะเพิ่มเติมเอกสารชี้แจงข้อมูลอาสาสมัคร (Information sheet)`,
        //         icon: 'warning',
        //     });
        //     return false;
        // } else if (!this.form.adviceResearcher) {
        //     Swal.fire({
        //         title: 'หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย',
        //         text: `กรุณาระบุ ข้อเสนอแนะเพิ่มเติมในส่วนของวิธีการดําเนินการวิจัย (Scientific Assessment)`,
        //         icon: 'warning',
        //     });
        //     return false;
        // } else if (!this.form.adviceEthical) {
        //     Swal.fire({
        //         title: 'หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย',
        //         text: `กรุณาระบุ ข้อเสนอแนะเพิ่มเติมประเด็นจริยธรรมการวิจัย (Ethical Issue)`,
        //         icon: 'warning',
        //     });
        //     return false;
      } else if (!this.form.riskRatio) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก อัตราส่วนระหว่างความเสี่ยงและผลประโยชน์`,
          icon: "warning",
        });
        return false;
      } else if (!this.form.riskCategories) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก ความรุนแรงของความเสี่ยง`,
          icon: "warning",
        });
        return false;
      } else if (!this.form.vulnerableSubject) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก กลุ่มบุคคลที่เปราะบางและอ่อนแอ`,
          icon: "warning",
        });
        return false;
      } else if (!this.form.assentForm) {
        Swal.fire({
          title: "หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย",
          text: `กรุณาเลือก เอกสารการให้ความยินยอมของอาสาสมัครที่เป็นเด็กอายุ 7 ปีขึ้นไป แต่น้อยกว่า 18 ปี`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.form.expeditedSummary &&
        this.researchType === "Expedited"
      ) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Expedited review",
          text: `กรุณาเลือก สรุปความเห็น`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.form.expeditedDeadline &&
        this.researchType === "Expedited"
      ) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Expedited review",
          text: `กรุณาเลือก กำหนดการส่งรายงานความก้าวหน้าของการวิจัย`,
          icon: "warning",
        });
        return false;
      } else if (
        this.form.expeditedDeadline === "3" &&
        !this.form.expeditedOtherDeadline &&
        this.researchType === "Expedited"
      ) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Expedited review",
          text: `กรุณาระบุ กำหนดการส่งรายงานความก้าวหน้าของการวิจัย อื่นๆ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.form.expeditedRecommendToMeet &&
        this.researchType === "Expedited"
      ) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Expedited review",
          text: `กรุณาระบุ แนะนำให้พบ`,
          icon: "warning",
        });
        return false;
      } else if (
        this.form.expeditedRecommendToMeet === "3" &&
        !this.form.expeditedExpertConsultant &&
        this.researchType === "Expedited"
      ) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Expedited review",
          text: `กรุณาระบุ ผู้เชี่ยวชาญ (Expert consultant)`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.form.fullBoardSummary &&
        this.researchType === "Full Board"
      ) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Full Board",
          text: `กรุณาระบุ สรุปความเห็น`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.form.fullBoardDeadline &&
        this.researchType === "Full Board"
      ) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Full Board",
          text: `กรุณาเลือก กำหนดการส่งรายงานความก้าวหน้าของการวิจัย`,
          icon: "warning",
        });
        return false;
      } else if (
        this.form.fullBoardDeadline === "3" &&
        !this.form.fullBoardOtherDeadline &&
        this.researchType === "Full Board"
      ) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Full Board",
          text: `กรุณาระบุ กำหนดการส่งรายงานความก้าวหน้าของการวิจัย อื่นๆ`,
          icon: "warning",
        });
        return false;
      } else if (
        !this.form.fullBoardRecommendToMeet &&
        this.researchType === "Full Board"
      ) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Full Board",
          text: `กรุณาระบุ แนะนำให้พบ`,
          icon: "warning",
        });
        return false;
      } else if (
        this.form.fullBoardRecommendToMeet === "3" &&
        !this.form.fullBoardExpertConsultant &&
        this.researchType === "Full Board"
      ) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Full Board",
          text: `กรุณาระบุ ผู้เชี่ยวชาญ (Expert consultant)`,
          icon: "warning",
        });
        return false;
      } else if (!this.form.signature) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Full Board",
          text: `กรุณาระบุ ผู้ประเมิน`,
          icon: "warning",
        });
        return false;
      } else if (!this.form.order) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Full Board",
          text: `กรุณาระบุ คนที่`,
          icon: "warning",
        });
        return false;
      } else if (!this.form.estimateDate) {
        Swal.fire({
          title: "กรณีพิจารณาแบบ Full Board",
          text: `กรุณาระบุ วันที่`,
          icon: "warning",
        });
        return false;
      } else {
        return true;
      }
    },
    getRO03_1() {
      this.isLoading = true;
      let data = {
        order: this.$route.query.order,
        researchID: this.$route.query.id,
      };
      this.$store
        .dispatch("FormRO/getRO03_1", data)
        .then((res) => {
          if (res != "don't have ro03_1 yet") {
            console.log("res", res);
            this.form.researchCode = res.researchCode;
            this.form.firstName = res.firstName;
            this.form.lastName = res.lastName;
            this.form.researchName = res.researchName;
            this.checkboxGet(res.isAppropriate1, "isAppropriate1");
            this.form.advice1 = res.advice1;
            this.checkboxGet(res.isAppropriate2, "isAppropriate2");
            this.form.advice2 = res.advice2;
            this.checkboxGet(res.isAppropriate3, "isAppropriate3");
            this.form.advice3 = res.advice3;
            this.checkboxGet(res.isAppropriate4, "isAppropriate4");
            this.form.advice4 = res.advice4;
            this.checkboxGet(res.isAppropriate5, "isAppropriate5");
            this.form.advice5 = res.advice5;
            this.checkboxGet(res.isAppropriate6, "isAppropriate6");
            this.form.advice6 = res.advice6;
            this.checkboxGet(res.isAppropriate7, "isAppropriate7");
            this.form.advice7 = res.advice7;
            this.checkboxGet(res.isAppropriate8, "isAppropriate8");
            this.form.advice8 = res.advice8;
            this.checkboxGet(res.isAppropriate9, "isAppropriate9");
            this.form.advice9 = res.advice9;
            this.checkboxGet(res.isAppropriate10, "isAppropriate10");
            this.form.advice10 = res.advice10;
            this.checkboxGet(res.isAppropriate11, "isAppropriate11");
            this.form.advice11 = res.advice11;
            this.checkboxGet(res.isAppropriate12, "isAppropriate12");
            this.form.advice12 = res.advice12;
            this.checkboxGet(res.isAppropriate13, "isAppropriate13");
            this.form.advice13 = res.advice13;
            this.checkboxGet(res.isAppropriate14, "isAppropriate14");
            this.form.advice14 = res.advice14;
            this.checkboxGet(res.isAppropriate14_1, "isAppropriate14_1");
            this.form.advice14_1 = res.advice14_1;
            this.checkboxGet(res.isAppropriate14_2, "isAppropriate14_2");
            this.form.advice14_2 = res.advice14_2;
            this.checkboxGet(res.isAppropriate15, "isAppropriate15");
            this.form.advice15 = res.advice15;
            this.checkboxGet(res.isAppropriate16, "isAppropriate16");
            this.form.advice16 = res.advice16;
            this.checkboxGet(res.isAppropriate17, "isAppropriate17");
            this.form.advice17 = res.advice17;
            this.checkboxGet(res.isAppropriate18, "isAppropriate18");
            this.form.advice18 = res.advice18;
            this.checkboxGet(res.isAppropriate19, "isAppropriate19");
            this.form.advice19 = res.advice19;
            this.checkboxGet(res.isAppropriate19_1, "isAppropriate19_1");
            this.form.advice19_1 = res.advice19_1;
            this.checkboxGet(res.isAppropriate19_2, "isAppropriate19_2");
            this.form.advice19_2 = res.advice19_2;
            this.checkboxGet(res.isAppropriate20, "isAppropriate20");
            this.form.advice20 = res.advice20;
            this.checkboxGet(res.isAppropriate20_1, "isAppropriate20_1");
            this.form.advice20_1 = res.advice20_1;
            this.checkboxGet(res.isAppropriate20_2, "isAppropriate20_2");
            this.form.advice20_2 = res.advice20_2;
            this.checkboxGet(res.isAppropriate20_3, "isAppropriate20_3");
            this.form.advice20_3 = res.advice20_3;
            this.checkboxGet(res.isAppropriate20_4, "isAppropriate20_4");
            this.form.advice20_4 = res.advice20_4;
            this.checkboxGet(res.isAppropriate21, "isAppropriate21");
            this.form.advice21 = res.advice21;
            this.checkboxGet(res.isAppropriate22, "isAppropriate22");
            this.form.advice22 = res.advice22;
            this.checkboxGet(res.isAppropriate23, "isAppropriate23");
            this.form.advice23 = res.advice23;
            this.checkboxGet(res.isAppropriate23_1, "isAppropriate23_1");
            this.form.advice23_1 = res.advice23_1;
            this.checkboxGet(res.isAppropriate23_2, "isAppropriate23_2");
            this.form.advice23_2 = res.advice23_2;
            this.checkboxGet(res.isAppropriate24, "isAppropriate24");
            this.form.advice24 = res.advice24;
            this.checkboxGet(res.isAppropriate25, "isAppropriate25");
            this.form.advice25 = res.advice25;
            this.checkboxGet(res.isAppropriate25_1, "isAppropriate25_1");
            this.form.advice25_1 = res.advice25_1;
            this.checkboxGet(res.isAppropriate26, "isAppropriate26");
            this.form.advice26 = res.advice26;
            this.checkboxGet(res.isAppropriate26_1, "isAppropriate26_1");
            this.form.advice26_1 = res.advice26_1;
            this.checkboxGet(res.isAppropriate26_2, "isAppropriate26_2");
            this.form.advice26_2 = res.advice26_2;
            this.checkboxGet(res.isAppropriate26_3, "isAppropriate26_3");
            this.form.advice26_3 = res.advice26_3;
            this.checkboxGet(res.isAppropriate26_4, "isAppropriate26_4");
            this.form.advice26_4 = res.advice26_4;
            this.checkboxGet(res.isAppropriate26_5, "isAppropriate26_5");
            this.form.advice26_5 = res.advice26_5;
            this.checkboxGet(res.isAppropriate26_6, "isAppropriate26_6");
            this.form.advice26_6 = res.advice26_6;
            this.checkboxGet(res.isAppropriate27, "isAppropriate27");
            this.form.advice27 = res.advice27;
            this.checkboxGet(res.isAppropriate28, "isAppropriate28");
            this.form.advice28 = res.advice28;
            this.checkboxGet(res.isAppropriate29, "isAppropriate29");
            this.form.advice29 = res.advice29;
            this.checkboxGet(res.isAppropriate30, "isAppropriate30");
            this.form.advice30 = res.advice30;
            this.checkboxGet(res.isAppropriate31, "isAppropriate31");
            this.form.advice31 = res.advice31;
            this.checkboxGet(res.isAppropriate32, "isAppropriate32");
            this.form.advice32 = res.advice32;
            this.checkboxGet(res.isAppropriate33, "isAppropriate33");
            this.form.advice33 = res.advice33;
            this.checkboxGet(res.isAppropriate33_1, "isAppropriate33_1");
            this.form.advice33_1 = res.advice33_1;
            this.checkboxGet(res.isAppropriate33_2, "isAppropriate33_2");
            this.form.advice33_2 = res.advice33_2;
            this.checkboxGet(res.isAppropriate34, "isAppropriate34");
            this.form.advice34 = res.advice34;
            this.checkboxGet(res.isAppropriate35, "isAppropriate35");
            this.form.advice35 = res.advice35;
            this.checkboxGet(res.isAppropriate36, "isAppropriate36");
            this.form.advice36 = res.advice36;
            this.checkboxGet(res.isAppropriate37, "isAppropriate37");
            this.form.advice37 = res.advice37;
            this.checkboxGet(res.isAppropriate38, "isAppropriate38");
            this.form.advice38 = res.advice38;
            this.checkboxGet(res.isAppropriate39, "isAppropriate39");
            this.form.advice39 = res.advice39;
            this.checkboxGet(res.isAppropriate40, "isAppropriate40");
            this.form.advice40 = res.advice40;
            this.checkboxGet(res.isAppropriate41, "isAppropriate41");
            this.form.advice41 = res.advice41;
            this.checkboxGet(res.isAppropriate42, "isAppropriate42");
            this.form.advice42 = res.advice42;
            this.checkboxGet(res.isAppropriate43, "isAppropriate43");
            this.form.advice43 = res.advice43;
            this.checkboxGet(res.isAppropriate44, "isAppropriate44");
            this.form.advice44 = res.advice44;
            this.form.checkbox12_1 = res.checkbox12_1;
            this.form.checkbox12_2 = res.checkbox12_2;
            this.form.checkbox12_3 = res.checkbox12_3;
            this.form.checkbox12_4 = res.checkbox12_4;
            this.form.checkbox12_5 = res.checkbox12_5;
            this.form.checkbox12_6 = res.checkbox12_6;
            this.form.checkbox12_7 = res.checkbox12_7;
            this.form.checkbox12_8 = res.checkbox12_8;
            this.form.checkbox12_9 = res.checkbox12_9;
            this.form.checkbox12_10 = res.checkbox12_10;
            this.form.checkbox12_11 = res.checkbox12_11;
            this.form.checkbox12_12 = res.checkbox12_12;
            this.form.checkbox12_13 = res.checkbox12_13;
            this.form.checkbox12_14 = res.checkbox12_14;
            this.form.checkbox12_15 = res.checkbox12_15;
            this.form.checkbox12_16 = res.checkbox12_16;
            this.form.checkbox12_17 = res.checkbox12_17;
            this.form.checkbox12_18 = res.checkbox12_18;
            this.form.checkbox13_1 = res.checkbox13_1;
            this.form.checkbox13_2 = res.checkbox13_2;
            this.form.checkbox13_3 = res.checkbox13_3;
            this.form.checkbox13_4 = res.checkbox13_4;
            this.form.checkbox13_5 = res.checkbox13_5;
            this.form.checkbox13_6 = res.checkbox13_6;
            this.form.checkbox13_7 = res.checkbox13_7;
            this.form.checkbox13_8 = res.checkbox13_8;
            this.form.checkbox13_9 = res.checkbox13_9;
            this.form.checkbox13_10 = res.checkbox13_10;
            this.form.checkbox13_11 = res.checkbox13_11;
            this.form.checkbox13_12 = res.checkbox13_12;
            this.form.checkbox13_13 = res.checkbox13_13;
            this.form.checkbox13_14 = res.checkbox13_14;
            this.form.checkbox13_15 = res.checkbox13_15;
            this.form.checkbox13_16 = res.checkbox13_16;
            this.form.checkbox13_17 = res.checkbox13_17;
            this.form.checkbox13_18 = res.checkbox13_18;
            this.form.checkbox13_19 = res.checkbox13_19;
            this.form.checkbox13_20 = res.checkbox13_20;
            this.form.checkbox13_21 = res.checkbox13_21;
            this.form.checkbox13_22 = res.checkbox13_22;
            this.form.checkbox13_23 = res.checkbox13_23;
            this.form.checkbox13_24 = res.checkbox13_24;
            this.form.checkbox13_25 = res.checkbox13_25;
            this.form.checkbox13_26 = res.checkbox13_26;
            this.form.checkbox13_27 = res.checkbox13_27;
            this.form.checkbox13_28 = res.checkbox13_28;
            this.form.checkbox13_29 = res.checkbox13_29;
            this.form.checkbox13_30 = res.checkbox13_30;
            this.form.checkbox13_31 = res.checkbox13_31;
            this.form.checkbox13_32 = res.checkbox13_32;
            this.form.checkbox13_33 = res.checkbox13_33;
            this.form.checkbox13_34 = res.checkbox13_34;
            this.form.checkbox13_35 = res.checkbox13_35;
            this.form.checkbox13_36 = res.checkbox13_36;
            this.form.checkbox13_37 = res.checkbox13_37;
            this.form.checkbox19_1 = res.checkbox19_1;
            this.form.checkbox19_2 = res.checkbox19_2;
            this.form.checkbox19_3 = res.checkbox19_3;
            this.form.checkbox19_4 = res.checkbox19_4;
            this.form.checkbox19_5 = res.checkbox19_5;
            this.form.checkbox19_6 = res.checkbox19_6;
            this.form.checkbox19_7 = res.checkbox19_7;
            this.form.checkbox19_8 = res.checkbox19_8;
            this.form.checkbox19_9 = res.checkbox19_9;
            this.form.checkbox19_10 = res.checkbox19_10;
            this.form.otherAnswer = res.otherAnswer;
            this.form.adviceResearch = res.adviceResearch;
            this.form.adviceProcess = res.adviceProcess;
            this.form.adviceDoc = res.adviceDoc;
            this.form.adviceResearcher = res.adviceResearcher;
            this.form.adviceEthical = res.adviceEthical;
            this.form.riskRatio = res.riskRatio ? res.riskRatio.toString() : "";
            this.form.riskCategories = res.riskCategories
              ? res.riskCategories.toString()
              : "";
            this.form.vulnerableSubject = res.vulnerableSubject
              ? res.vulnerableSubject.toString()
              : "";
            this.form.assentForm = res.assentForm
              ? res.assentForm.toString()
              : "";
            if (this.researchType === "Expedited") {
              this.form.expeditedSummary = res.expeditedSummary
                ? res.expeditedSummary.toString()
                : "";
              this.form.expeditedDeadline = res.expeditedDeadline
                ? res.expeditedDeadline.toString()
                : "";
              this.form.expeditedOtherDeadline = res.expeditedOtherDeadline;
              this.form.expeditedRecommendToMeet = res.expeditedRecommendToMeet
                ? res.expeditedRecommendToMeet.toString()
                : "";
              this.form.expeditedExpertConsultant =
                res.expeditedExpertConsultant;
            }
            if (this.researchType === "Full Board") {
              this.form.fullBoardSummary = res.fullBoardSummary
                ? res.fullBoardSummary.toString()
                : "";
              this.form.fullBoardDeadline = res.fullBoardDeadline
                ? res.fullBoardDeadline.toString()
                : "";
              this.form.fullBoardOtherDeadline = res.fullBoardOtherDeadline;
              this.form.fullBoardRecommendToMeet = res.fullBoardRecommendToMeet
                ? res.fullBoardRecommendToMeet.toString()
                : "";
              this.form.fullBoardExpertConsultant =
                res.fullBoardExpertConsultant;
            }
            if (res.signature) this.form.signature = res.signature;
            else this.form.signature = this.$route.query.reviewerName;
            this.form.order = res.order;
            this.isSubmit = res.isSubmit;
            this.form.isCognitive = res.isCognitive;
            this.form.isInstitutional = res.isInstitutional;
            this.form.isDeferral = res.isDeferral;
            this.form.isMedical = res.isMedical;
            this.form.isEconomic = res.isEconomic;
            this.form.isSocial = res.isSocial;
            this.form.isOtherAnswer = res.isOtherAnswer;
            this.form.ro03_3File = res.ro03_3File;
            this.form.ro04_2File = res.ro04_2File;
            this.ro03_3FilePath = res.ro03_3FilePath;
            this.ro04_2FilePath = res.ro04_2FilePath;
            this.updateDate("estimateDateGet", res.estimateDate);
          }
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    onClickGenerate(text) {
      if (text === "adviceResearcher") {
        this.form.adviceResearcher =
          (this.form.advice1 &&
            this.checkNull("หลักการและเหตุผล(Rationale)", this.form.advice1) +
              "\n") +
          (this.form.advice2 &&
            this.checkNull(
              "การทบทวนวรรณกรรมที่เกี่ยวข้อง(Literaturereview)",
              this.form.advice2
            ) + "\n") +
          (this.form.advice3 &&
            this.checkNull("วัตถุประสงค์ (Objective)", this.form.advice3) +
              "\n") +
          (this.form.advice4 &&
            this.checkNull("รูปแบบการวิจัย (Study design)", this.form.advice4) +
              "\n") +
          (this.form.advice5 &&
            this.checkNull(
              "กลุ่มประชากรที่ศึกษา (Study population)",
              this.form.advice5
            ) + "\n") +
          (this.form.advice6 &&
            this.checkNull("ขนาดตัวอย่าง (Sample size)", this.form.advice6) +
              "\n") +
          (this.form.advice7 &&
            this.checkNull(
              "การคัดเลือกอาสาสมัครที่เข้าโครงการ (Inclusion criteria) ICH-GCP 6.5",
              this.form.advice7
            ) + "\n") +
          (this.form.advice8 &&
            this.checkNull(
              "การคัดอาสาสมัครออกจากโครงการวิจัย (Exclusion criteria)",
              this.form.advice8
            ) + "\n") +
          (this.form.advice9 &&
            this.checkNull(
              "การถอนอาสาสมัครออกจากโครงการ (Withdrawal Criteria)",
              this.form.advice9
            ) + "\n") +
          (this.form.advice10 &&
            this.checkNull(
              "กระบวนการ/หัตถการที่ใช้(Procedures used)",
              this.form.advice10
            ) + "\n") +
          (this.form.advice11 &&
            this.checkNull(
              "การใช้กลุ่มควบคุมหรือยาหลอก (Placebo used)",
              this.form.advice11
            ) + "\n") +
          (this.form.advice12 &&
            this.checkNull(
              "เครื่องมือหรือวิธีทดสอบที่ใช้ในการวิจัย (Medical devices) (ใช้เอกสาร R0 04_3_2563 แนบ)",
              this.form.advice12
            ) + "\n") +
          (this.form.advice13 &&
            this.checkNull(
              "การศึกษาเกี่ยวกับการเก็บวัตถุทางพันธุศาสตร์และวัสดุชีวภาพ (ใช้เอกสาร R0 04_2_2563 แนบ)",
              this.form.advice13
            ) + "\n") +
          (this.form.advice14 &&
            this.checkNull(
              "วิธีการวัดผลการวิจัย (Research assessment)",
              this.form.advice14
            ) + "\n") +
          (this.form.advice14_1 &&
            this.checkNull(
              "การประเมินประสิทธิภาพ (Efficacy)",
              this.form.advice14_1
            ) + "\n") +
          (this.form.advice14_2 &&
            this.checkNull(
              "การประเมินความปลอดภัย (Safety)",
              this.form.advice14_2
            ) + "\n") +
          (this.form.advice15 &&
            this.checkNull(
              "การเฝ้าระวังผลแทรกซ้อนและการแก้ไข (Monitoring of complications and solutions)",
              this.form.advice15
            ) + "\n") +
          (this.form.advice16 &&
            this.checkNull(
              "จํานวนและปริมาณของเลือด/สิ่งส่งตรวจ (Blood/specimen)",
              this.form.advice16
            ) + "\n") +
          (this.form.advice17 &&
            this.checkNull(
              "ระยะเวลา/จํานวนครั้งของการติดตาม (Duration and number of follow-up)",
              this.form.advice17
            ) + "\n") +
          (this.form.advice18 &&
            this.checkNull(
              "สถิติที่ใช้ในการวิเคราะห์(Statistics)",
              this.form.advice18
            ) + "\n");
      } else if (text === "adviceEthical") {
        this.form.adviceEthical =
          (this.form.advice19 &&
            this.checkNull(
              "การใช้อาสาสมัครกลุ่มเปราะบาง (Vulnerable participants)",
              this.form.advice19
            ) + "\n") +
          (this.form.advice19_1 &&
            this.checkNull(
              "การจัดกลุ่มเปราะบาง(Identification)",
              this.form.advice19_1
            ) + "\n") +
          (this.form.advice19_2 &&
            this.checkNull(
              "การปกป้องคุ้มครองเพิ่มเติม (Additional safeguard)",
              this.form.advice19_2
            ) + "\n") +
          (this.form.advice20 &&
            this.checkNull(
              "ความเสี่ยงต่อสุขภาพของอาสาสมัคร (Risks to the health)",
              this.form.advice20
            ) + "\n") +
          (this.form.advice20_1 &&
            this.checkNull(
              "ความเสี่ยงทางกาย (Physical risk)",
              this.form.advice20_1
            ) + "\n") +
          (this.form.advice20_2 &&
            this.checkNull(
              "ความเสี่ยงทางจิตใจ (Psychological risk)",
              this.form.advice20_2
            ) + "\n") +
          (this.form.advice20_3 &&
            this.checkNull("ความเสี่ยงอื่น ๆ", this.form.advice20_3) + "\n") +
          (this.form.advice20_4 &&
            this.checkNull(
              "การลดความเสี่ยง (Minimizing the risk)",
              this.form.advice20_4
            ) + "\n") +
          (this.form.advice21 &&
            this.checkNull(
              "ความเสี่ยงต่อสุขภาพของตัวอ่อนหรือบุตรในครรภ์หรือคู่สมรส (Risks to the health of the embryo or unborn child)",
              this.form.advice21
            ) + "\n") +
          (this.form.advice22 &&
            this.checkNull(
              "ผลกระทบต่อชุมชนที่เข้าร่วมการวิจัย (Risks to community)",
              this.form.advice22
            ) + "\n") +
          (this.form.advice23 &&
            this.checkNull(
              "ประโยชน์ต่ออาสาสมัครโดยตรง(Direct benefits)",
              this.form.advice23
            ) + "\n") +
          (this.form.advice23_1 &&
            this.checkNull(
              "ขณะเข้าร่วม (During the study)",
              this.form.advice23_1
            ) + "\n") +
          (this.form.advice23_2 &&
            this.checkNull(
              "หลังการเข้าร่วม (Post-study benefits)",
              this.form.advice23_2
            ) + "\n") +
          (this.form.advice24 &&
            this.checkNull(
              "ประโยชน์ต่อชุมชนที่เข้าร่วมการวิจัย(Benefits to community)",
              this.form.advice24
            ) + "\n") +
          (this.form.advice25 &&
            this.checkNull(
              "ประโยชน์ต่อสังคม(Benefits to society)",
              this.form.advice25
            ) + "\n") +
          (this.form.advice25_1 &&
            this.checkNull(
              "การประเมินประโยชน์และความเสี่ยง (Benefit/risk ratio)",
              this.form.advice25_1
            ) + "\n");
      } else if (text === "adviceProcess") {
        this.form.adviceProcess =
          (this.form.advice26 &&
            this.checkNull("กระบวนการขอความยินยอม", this.form.advice26) +
              "\n") +
          (this.form.advice26_1 &&
            this.checkNull("บุคคลที่ทําการขอความยินยอม", this.form.advice26_1) +
              "\n") +
          (this.form.advice26_2 &&
            this.checkNull(
              "ช่วงเวลาที่ทําการขอความยินยอม",
              this.form.advice26_2
            ) + "\n") +
          (this.form.advice26_3 &&
            this.checkNull(
              "สถานที่ที่ทําการขอความยินยอม",
              this.form.advice26_3
            ) + "\n") +
          (this.form.advice26_4 &&
            this.checkNull(
              "กระบวนการเชิญชวนอาสาสมัครเข้าร่วมโครงการวิจัย",
              this.form.advice26_4
            ) + "\n") +
          (this.form.advice26_5 &&
            this.checkNull(
              "ความมีอิสระในการตัดสินใจของผู้เข้าร่วมโครงการวิจัย",
              this.form.advice26_5
            ) + "\n") +
          (this.form.advice26_6 &&
            this.checkNull(
              "รูปแบบและวิธีการสื่อสารข้อมูลกับอาสาสมัคร",
              this.form.advice26_6
            ) + "\n");
      } else if (text === "adviceDoc") {
        this.form.adviceDoc =
          (this.form.advice27 &&
            this.checkNull("การแจ้งหลักการและเหตุผล", this.form.advice27) +
              "\n") +
          (this.form.advice28 &&
            this.checkNull(
              "การแจ้งวัตถุประสงค์ของการวิจัย",
              this.form.advice28
            ) + "\n") +
          (this.form.advice29 &&
            this.checkNull("ระบุแหล่งทุนสนับสนุน", this.form.advice29) + "\n") +
          (this.form.advice30 &&
            this.checkNull(
              "ขั้นตอนการปฏิบัติตัวของอาสาสมัคร",
              this.form.advice30
            ) + "\n") +
          (this.form.advice31 &&
            this.checkNull("ระบุความเสี่ยงและผลแทรกซ้อน", this.form.advice31) +
              "\n") +
          (this.form.advice32 &&
            this.checkNull(
              "ประโยชน์ที่ได้รับจากการเข้าร่วมวิจัย",
              this.form.advice32
            ) + "\n") +
          (this.form.advice33 &&
            this.checkNull("ความเป็นอิสระในการตัดสินใจ", this.form.advice33) +
              "\n") +
          (this.form.advice33_1 &&
            this.checkNull(
              "การเข้าร่วมโครงการเป็นโดยสมัครใจ",
              this.form.advice33_1
            ) + "\n") +
          (this.form.advice33_2 &&
            this.checkNull(
              "สิทธิในการถอนตัวจากโครงการวิจัย",
              this.form.advice33_2
            ) + "\n") +
          (this.form.advice34 &&
            this.checkNull(
              "ทางเลือกอื่นหากไม่เข้าร่วมโครงการ",
              this.form.advice34
            ) + "\n") +
          (this.form.advice35 &&
            this.checkNull(
              "การให้การดูแลทางการแพทย์ขณะเข้าร่วมงานวิจัย",
              this.form.advice35
            ) + "\n") +
          (this.form.advice36 &&
            this.checkNull(
              "การจ่ายค่าตอบแทน/ค่าเดินทาง/ค่าใช้จ่าย/ค่าชดเชยแก่อาสาสมัคร",
              this.form.advice36
            ) + "\n") +
          (this.form.advice37 &&
            this.checkNull(
              "การเก็บรักษาความลับของอาสาสมัคร",
              this.form.advice37
            ) + "\n") +
          (this.form.advice38 &&
            this.checkNull(
              "ชื่อ ที่อยู่และเบอร์โทรศัพท์ติดต่อผู้วิจัย",
              this.form.advice38
            ) + "\n") +
          (this.form.advice39 &&
            this.checkNull(
              "ที่อยู่และเบอร์โทรศัพท์ติดต่อคณะกรรมการ",
              this.form.advice39
            ) + "\n") +
          (this.form.advice40 &&
            this.checkNull("การใช้ภาษาที่เหมาะสม", this.form.advice40) + "\n");
      } else {
        this.form.adviceResearch =
          (this.form.advice41 &&
            this.checkNull(
              "พื้นฐานอาชีพและประสบการณ์ของผู้วิจัย",
              this.form.advice41
            ) + "\n") +
          (this.form.advice42 &&
            this.checkNull("Conflict of interest", this.form.advice42) + "\n") +
          (this.form.advice43 &&
            this.checkNull(
              "ประวัติการอบรมจริยธรรมการวิจัยของผู้วิจัย และผู้ร่วมโครงการวิจัย",
              this.form.advice43
            ) + "\n");
      }
    },
    checkNull(text, val) {
      console.log(val);
      if (val && val !== undefined && val !== "undefined") {
        return text + "\n" + "- " + val;
      }
    },
    onUploadFile(fileName, e) {
      var formData = new FormData();
      formData.append(fileName, e);
      axios
        .post(domain + "/api/upload-file-pre", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.fileName !== undefined) {
            this.form[fileName] = response.data.fileName;
          }
        })
        .catch(function(error) {});
    },
    onHandleBtn(index) {
      document.getElementById(index).click();
    },
  },
};
</script>

<style lang="scss">
.table-ro3 {
  /*** Table Styles **/
  .table-style {
    .v-input__slot {
      align-items: center;
      justify-content: center;
    }

    .table-fill {
      background: white;
      border-radius: 3px;
      border-collapse: collapse;
      margin: auto;
      padding: 5px;
      width: 100%;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      animation: float 5s infinite;
      border-bottom: 5px solid #544a44;
    }

    th {
      color: #ffffff;
      background: #3e7662;
      border-top: 5px solid #544a44;
      border-right: 0.75px solid #ffffff;
      font-weight: 700;
      padding: 15px;
      vertical-align: middle;
    }

    th:first-child {
      border-top-left-radius: 3px;
    }

    th:last-child {
      border-top-right-radius: 3px;
      border-right: none;
    }

    tr:first-child {
      border-top: none;
    }

    tr:last-child {
      /*border-bottom:5px solid #544A44;*/
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 3px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 3px;
    }

    td {
      background: #ffffff;
      padding: 10px 30px 10px 30px;
      text-align: left;
      vertical-align: middle;
      font-weight: 700;
      color: black;
      border-right: 0.5px solid #544a44;
    }

    td:last-child {
      border-right: 0px;
    }

    th.text-left {
      text-align: left;
    }

    th.text-center {
      text-align: center;
    }

    th.text-right {
      text-align: right;
    }

    td.text-left {
      text-align: left;
    }

    td.text-center {
      text-align: center;
    }

    td.text-right {
      text-align: right;
    }
  }
}

.text-field-color {
  .theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #cc3d45;
  }
}

.text-field-margin {
  .v-text-field {
    padding: 0;
    margin: 0;
  }
}
.page_break {
  page-break-before: always;
}
</style>
